export type Maybe<T> = T;
export type InputMaybe<T> = T;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Date: any;
  JsonObjectScalar: any;
  Long: any;
  Map_String_ObjectScalar: any;
  Map_String_StringScalar: any;
  ObjectScalar: any;
  UNREPRESENTABLE: any;
};

export enum Access {
  /** Api key access level of read. */
  READ = 'READ',
  /** Api key access level of write. */
  WRITE = 'WRITE'
}

export enum AccessLevel {
  DENY = 'DENY',
  READ = 'READ',
  WRITE = 'WRITE'
}

export enum AccessType {
  FULL = 'FULL',
  LIMITED = 'LIMITED',
  READ_LOG = 'READ_LOG',
  USER = 'USER',
  XDR_USER = 'XDR_USER'
}

export type AccountData = Node & {
  __typename?: 'AccountData';
  /** Console url for the singularity XDR user */
  S1ConsoleURL: Maybe<Scalars['String']>;
  /** Details of the currently active team for this user. If the user is not linked to another team, the response will contain the user's own account details. */
  activeTeam: TeamData;
  /**
   * The id of the currently active team for this user. If the user is not linked to another team, the response will contain the user's own id.
   * @deprecated To be replaced with activeTeam
   */
  activeTeamId: Scalars['String'];
  /** Permission for the linked account */
  activeTeamPermission: Permission;
  /**
   * Details of the currently active team for this user. If the user is not linked to another team, the response will contain the user's own account details.
   * @deprecated To be replaced with activeTeam
   */
  activeTeamV2: TeamData;
  /** Get billing information for the accountId specified. */
  billingInformation: Maybe<BillingInformation>;
  /** Type of billing for a customer */
  billingType: Maybe<BillingType>;
  /** Whether or not the user has permissions to modify the account's billing plan. */
  canChangeBillingPlan: Scalars['Boolean'];
  /** Get the non-sensitive credit card information for the given account. */
  cardInformation: Maybe<CardInformation>;
  /** If the given account has uploaded/imported log data, or been linked to another account with data */
  dataAvailability: Scalars['Boolean'];
  /** Default time span for all Scalyr searches between 5 minutes and 4 hours. This does not affect saved searches and the default is 4 hours if the user has left it unspecified. */
  defaultSearchTimeSpan: Scalars['String'];
  /** Email for the current logged in user account */
  email: Scalars['String'];
  /** Is user account has associated credit card record */
  hasCreditCard: Scalars['Boolean'];
  /** User account id */
  id: Scalars['ID'];
  /** Whether or not this account have a custom plan or a pre-set plan. */
  isCustomPlan: Scalars['Boolean'];
  /** Return whether the account's e-mail address has to be verified. */
  isEmailVerificationRequired: Scalars['Boolean'];
  /** Return true if the given user has confirmed their e-mail address. */
  isEmailVerified: Scalars['Boolean'];
  /** Whether or not the user has a flex plan. Its a standard, non-custom plan with varying daily quota. */
  isFlexPlan: Scalars['Boolean'];
  /** Whether or not log overage notifications widget enabled. */
  isLogOverageNotificationsWidgetEnabled: Scalars['Boolean'];
  /** Determine whether this account is a master account AND it has a subsidiary (team) account other than itself. */
  isMasterWithSubsidiaries: Scalars['Boolean'];
  /** Is user account authenticated via SSO */
  isSSOAuthenticated: Scalars['Boolean'];
  /** Whether this user is a singularity XDR user */
  isSingularityXDRUser: Scalars['Boolean'];
  /** If the current account is part of a collection of team accounts rolling up into a single master billing account, masterAccountId is id of the master account. Otherwise masterAccountId is same as id of current account. */
  masterAccountId: Scalars['String'];
  /** Get plan data for account. */
  planData: PlanData;
  /** Get plan data for next billing cycle for account. */
  planDataForNextBillingCycle: Maybe<PlanData>;
  status: AccountStatus;
  /** List of teams the account has access to, sorted by most recently viewed */
  teams: Array<Maybe<TeamData>>;
  /** List of teams the account has access to, sorted by most recently viewed */
  teamsV2: Array<Maybe<TeamData>>;
  /** Trial ending time in ISO 8601 Notation. Will be "null" for non trial accounts */
  trialExpiresAt: Maybe<Scalars['String']>;
  type: AccountType;
  /** Return the XSRF token for the user */
  xsrfToken: Scalars['String'];
};

export enum AccountStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE'
}

export enum AccountType {
  /** Customer account with payment plan */
  PAID = 'PAID',
  /** Customer account without payment plan */
  TRIAL = 'TRIAL',
  /** Customer account does not have a plan set */
  UNKNOWN = 'UNKNOWN'
}

export type AgentVersion = {
  __typename?: 'AgentVersion';
  /** Agent version info */
  agent: AgentVersionDetails;
  /** Repo version info */
  repo: AgentVersionDetails;
};

export type AgentVersionDetails = {
  __typename?: 'AgentVersionDetails';
  /** Beta version */
  beta: Scalars['String'];
  /** Internal version */
  internal: Scalars['String'];
  /** Stable version */
  stable: Scalars['String'];
};

export type AlertInfo = {
  __typename?: 'AlertInfo';
  /** Addresses to which alert should be sent */
  alertAddresses: Scalars['String'];
  alertId: Maybe<Scalars['String']>;
  /** Alert's description */
  description: Scalars['String'];
  /** Time in minutes for which alert should be triggered, before addresses notified. Defaults to 0 */
  gracePeriod: Maybe<Scalars['Int']>;
  history: Maybe<Array<Maybe<AlertStatus>>>;
  lastStatus: Maybe<AlertStatus>;
  /** The total number of real alerts created from a single alert entry in the config file.If the alert's description, trigger, or alertAddress has a template key, a single alert entry in the alert config file creates multiple alerts.If no templating is used, numAlertsInGroup = 1 */
  numAlertsInGroup: Maybe<Scalars['Int']>;
  /**
   * Retrieves a list of power query expressions parsed out from this alert's trigger. For example a trigger expression of `tableRows:5m(tag='1' | group count() by id) > tableValue:5m(tag='2' | group estimate_distinct(id))` would result in a list of 2 `ParsedPowerQueryExpression` objects with the following values:
   * ```
   * [
   *   {
   *     powerQuery: "tag='1' | group count() by id",
   *     fn: tableRows,
   *   },
   *   {
   *     powerQuery: "tag='2' | group estimate_distinct(id)",
   *     fn: tableValue,
   *   }
   * ]
   * ```
   */
  parsedPowerQueryExpressions: Maybe<Array<Maybe<ParsedPowerQueryExpression>>>;
  /**
   * Retrieves a list of event query expressions parsed out from this alert's trigger. For example a trigger expression of `p90:5m(tag='1') > 1 && p10:10m(ageSecs where tag='b') > 2` would result in a list of 2 `ParsedExpression` objects with the following values:
   * ```
   * [
   *   {
   *     filter: "tag='1'",
   *     fn: p90,
   *     facet: "value"
   *   },
   *   {
   *     filter: "tag='b'",
   *     fn: p10,
   *     facet: "ageSecs"
   *   }
   * ]
   * ```
   */
  parsedTriggerExpressions: Maybe<Array<Maybe<ParsedExpression>>>;
  /** Time in minutes for after an alert is triggered, before addresses are re notified. Defaults to 60 */
  renotifyPeriod: Maybe<Scalars['Int']>;
  /** Time in minutes after an alert trigger is inactive, before addresses marked as resolved. Defaults to 5 */
  resolutionDelay: Maybe<Scalars['Int']>;
  silenceComment: Maybe<Scalars['String']>;
  silenced: Maybe<Scalars['Boolean']>;
  silencedUntilNs: Maybe<Scalars['Long']>;
  streakStartNs: Maybe<Scalars['Long']>;
  templateParameters: Maybe<Scalars['Map_String_ObjectScalar']>;
  /** Alert's trigger expression */
  trigger: Scalars['String'];
};

export type AlertInput = {
  alertAddresses: Scalars['String'];
  description: InputMaybe<Scalars['String']>;
  gracePeriod: InputMaybe<Scalars['Int']>;
  renotifyPeriod: InputMaybe<Scalars['Int']>;
  resolutionDelay: InputMaybe<Scalars['Int']>;
  trigger: Scalars['String'];
};

export enum AlertStatus {
  INCOMPLETE = 'INCOMPLETE',
  OK = 'OK',
  TRIGGERED = 'TRIGGERED'
}

export type AlertsConfig = {
  __typename?: 'AlertsConfig';
  /** Default alert notification address for this account */
  defaultAlertAddress: Maybe<Scalars['String']>;
};

export type Annotation = {
  __typename?: 'Annotation';
  /** Color of annotation in HEX RGB format. Should be in #ffffff format. */
  color: Scalars['String'];
  /** Text for annotation. */
  comment: Scalars['String'];
  /** Timestamp for annotation end. */
  endMs: Scalars['Long'];
  /** Labels for annotation. */
  labels: Array<Maybe<AnnotationLabel>>;
  /** Timestamp for annotation start. */
  startMs: Scalars['Long'];
};

export type AnnotationLabel = {
  __typename?: 'AnnotationLabel';
  key: Scalars['String'];
  value: Scalars['String'];
};

export type AnnotationLabelRequestInput = {
  key: Scalars['String'];
  value: Scalars['String'];
};

export type AnnotationRequestInput = {
  color: Scalars['String'];
  comment: Scalars['String'];
  endMs: Scalars['Long'];
  labels: Array<InputMaybe<AnnotationLabelRequestInput>>;
  startMs: Scalars['Long'];
};

export type BillingInformation = {
  __typename?: 'BillingInformation';
  address: Scalars['String'];
  city: Scalars['String'];
  company: Scalars['String'];
  country: Scalars['String'];
  firstname: Scalars['String'];
  lastname: Scalars['String'];
  state: Scalars['String'];
  zip: Scalars['String'];
};

export type BillingInformationInput = {
  address: Scalars['String'];
  city: Scalars['String'];
  company: Scalars['String'];
  country: Scalars['String'];
  firstname: Scalars['String'];
  lastname: Scalars['String'];
  state: Scalars['String'];
  zip: Scalars['String'];
};

export type BillingNotifications = {
  __typename?: 'BillingNotifications';
  /** BudgetNotification entity */
  budgetNotification: BudgetNotification;
  /** OverageNotificationSettings entity */
  overageNotificationSettings: OverageNotificationSettings;
};

export enum BillingType {
  channel = 'channel',
  salesLed = 'salesLed',
  selfServe = 'selfServe'
}

export type BudgetCategory = {
  __typename?: 'BudgetCategory';
  /** User account id. */
  accountId: Maybe<Scalars['String']>;
  /** Creation date and time of this category. */
  createdAt: Maybe<Scalars['String']>;
  /** Discard filters for the category. */
  filters: Maybe<Array<Maybe<BudgetCategoryDiscardFilter>>>;
  /** Id of the category. */
  id: Maybe<Scalars['ID']>;
  /** The last time we sent an email alerting that this category was beyond plannedGbPerDay. */
  lastOverageEmailAt: Maybe<Scalars['String']>;
  /** Filter for logs to include. */
  logFilter: Maybe<Scalars['String']>;
  /** Name of the category. */
  name: Maybe<Scalars['String']>;
  /** Planned cost per month. Defaults to -1. */
  plannedCostPerMonth: Maybe<Scalars['Float']>;
  /** Planned GBs per day. */
  plannedGbPerDay: Maybe<Scalars['Float']>;
  /** Position in the list. */
  position: Maybe<Scalars['Int']>;
  /** Date and time when this category last updated. */
  updatedAt: Maybe<Scalars['String']>;
};

export type BudgetCategoryDiscardFilter = {
  __typename?: 'BudgetCategoryDiscardFilter';
  /** Budget category this filter applies to. */
  categoryId: Maybe<Scalars['Int']>;
  /** Creation date and time of this discard filter. */
  createdAt: Maybe<Scalars['String']>;
  /** Determines for how long this filter will be treated as disabled. Null means disabled. */
  disabledUntil: Maybe<Scalars['String']>;
  /** Id of the BudgetCategoryDiscardFilter. */
  id: Maybe<Scalars['ID']>;
  /** Last updated date and time of this discard filter. */
  updatedAt: Maybe<Scalars['String']>;
  /** Which log entries this filter should be applied to. */
  value: Maybe<Scalars['String']>;
};

export type BudgetCategoryDiscardFilterRequestInput = {
  disabledUntil: InputMaybe<Scalars['String']>;
  filterValue: Scalars['String'];
};

export type BudgetCategoryRequestInput = {
  logFilter: Scalars['String'];
  name: Scalars['String'];
  plannedGbPerDay: Scalars['Float'];
};

export type BudgetCategoryVolume = {
  __typename?: 'BudgetCategoryVolume';
  /** Id of the related BudgetCategory. */
  categoryId: Maybe<Scalars['Int']>;
  /** Id of the related BudgetCategory. Duplicate of categoryId for FE reasons. */
  id: Scalars['Int'];
  /** Volume bytes. */
  volumeBytes: Maybe<Scalars['Float']>;
};

export type BudgetNotification = Node & {
  __typename?: 'BudgetNotification';
  EMPTY: Maybe<BudgetNotification>;
  /** Unique id of client account. */
  accountId: Scalars['String'];
  /** Is this notification disabled? */
  disabled: Scalars['Boolean'];
  /** List of emails to send. */
  emails: Array<Maybe<Scalars['String']>>;
  /** Unique id for notification. */
  id: Scalars['ID'];
};

export type BudgetNotificationRequestInput = {
  disabled: Scalars['Boolean'];
  emails: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type BudgetVolume = {
  __typename?: 'BudgetVolume';
  filter: Maybe<Scalars['String']>;
  volumeBytes: Maybe<Scalars['Float']>;
};

export type BulkExport = {
  __typename?: 'BulkExport';
  /** Time in milliseconds the job completes */
  completedTimestamp: Scalars['Long'];
  /** Percentage of bulk export that has completed */
  completionPercent: Scalars['Float'];
  /** Export job creator email */
  createdBy: Scalars['String'];
  /** Export job creation time */
  createdTimestamp: Scalars['Long'];
  /** Filename prefix (optional) */
  filenamePrefix: Maybe<Scalars['String']>;
  /** Export job id */
  id: Scalars['String'];
  /** Export job label (optional) */
  label: Maybe<Scalars['String']>;
  /** Output type */
  output: Maybe<Output>;
  /** Export job query */
  query: Scalars['String'];
  /** List of notification recipient emails (optional) */
  recipients: Maybe<Array<Maybe<Scalars['String']>>>;
  /** S3 bucket name for file export */
  s3Bucket: Scalars['String'];
  /** Export job status */
  status: Maybe<Status>;
  /** Export job time range */
  timeRange: LongRange;
};

export type BulkExportRequestInput = {
  filenamePrefix: InputMaybe<Scalars['String']>;
  label: InputMaybe<Scalars['String']>;
  output: InputMaybe<Output>;
  query: Scalars['String'];
  recipients: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  s3Bucket: Scalars['String'];
  timeRangeEnd: Scalars['String'];
  timeRangeStart: Scalars['String'];
};

export type BulkExportResolver = {
  __typename?: 'BulkExportResolver';
  /** Lists the account's bulk exports */
  listJobs: Maybe<Array<Maybe<BulkExport>>>;
};

export type CardInformation = {
  __typename?: 'CardInformation';
  brand: Maybe<Scalars['String']>;
  expirationMonth: Maybe<Scalars['Int']>;
  expirationYear: Maybe<Scalars['Int']>;
  lastFour: Maybe<Scalars['String']>;
};

export type Cell = {
  __typename?: 'Cell';
  /** Relative url to scalyr events corresponding to value in the cell. */
  url: Maybe<Scalars['String']>;
  /** Value to be displayed in cell. Check Column.format to know the format of the value */
  value: Maybe<Scalars['ObjectScalar']>;
};

export enum CellType {
  /** Number format with possible decimal places, except for "NaN", "-Infinity" and "+Infinity" which will be strings */
  NUMBER = 'NUMBER',
  /** Number from 0 - 100, used only in reports */
  PERCENTAGE = 'PERCENTAGE',
  /** Basic string format */
  STRING = 'STRING',
  /** Timestamp in epoch ns, μs, ms, or s */
  TIMESTAMP = 'TIMESTAMP'
}

export type Column = {
  __typename?: 'Column';
  decimalPlaces: Maybe<Scalars['Int']>;
  /**
   * Format of the returned values.
   * @deprecated Use type which is an enum
   */
  format: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
  scalyrJson: Maybe<Scalars['JsonObjectScalar']>;
  /** Data type of the Cell.value */
  type: Maybe<CellType>;
};

export type ConfigFile = {
  __typename?: 'ConfigFile';
  /** Content of the configuration file. */
  content: Maybe<Scalars['String']>;
  contentResolved: Scalars['Boolean'];
  /** Date of the configuration file creation. */
  createdDate: Maybe<Scalars['Date']>;
  /** Id of the configuration file. Duplicates 'name' field. */
  id: Maybe<Scalars['ID']>;
  /** Date of the configuration file last modification. */
  modifiedDate: Maybe<Scalars['Date']>;
  /** Name of the configuration file. */
  name: Maybe<Scalars['String']>;
  /** Config file is read only for the current user */
  readOnly: Scalars['Boolean'];
};

export type CustomFilterValueInput = {
  label: InputMaybe<Scalars['String']>;
  value: InputMaybe<Scalars['String']>;
};

export type CustomParameterValueInput = {
  label: InputMaybe<Scalars['String']>;
  value: InputMaybe<Scalars['String']>;
};

export type Dashboard = {
  __typename?: 'Dashboard';
  /** User-defined description of this dashboard. */
  description: Maybe<Scalars['String']>;
  /** Default timespan of this dashboard (e.g., "4h"). */
  duration: Maybe<Scalars['String']>;
  /** Stringified JSON for the filters in Dashboard */
  filters: Maybe<Scalars['String']>;
  /** Stringified JSON for the list of all this dashboard's visualizations, including graphs and data tables (aka reports). */
  graphs: Maybe<Scalars['String']>;
  /** True if it's a built-in Scalyr dashboard, or false if it's user-created. */
  isBuiltIn: Scalars['Boolean'];
  /** Name of this dashboard. */
  name: Scalars['String'];
  /** Stringified version of the this dashboard's JSON options stanza. */
  options: Maybe<Scalars['String']>;
  /** Stringified JSON for the Dropdown lists of values that are shown across the top to allow filtering. */
  parameters: Maybe<Scalars['String']>;
  /** Url template of this dashboard. __SERVER_HOST__ in urlTemplate should be replaced with original host name */
  urlTemplate: Maybe<Scalars['String']>;
  /** Version of the dashboard config settings. Dashboard versions are not incremental, and is just a hash of dashboard configuration. */
  version: Scalars['Int'];
};

export type DashboardFilterInput = {
  defaultValue: InputMaybe<Scalars['String']>;
  facet: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  values: InputMaybe<Array<InputMaybe<CustomFilterValueInput>>>;
};

export type DashboardOld = {
  __typename?: 'DashboardOld';
  /** User-defined description of this dashboard. */
  description: Maybe<Scalars['String']>;
  /** Default timespan of this dashboard (e.g., "4h"). */
  duration: Maybe<Scalars['String']>;
  /** Stringified JSON for the filters in Dashboard */
  filters: Maybe<Scalars['String']>;
  /** Stringified JSON for the list of all this dashboard's visualizations, including graphs and data tables (aka reports). */
  graphs: Maybe<Scalars['String']>;
  /** True if it's a built-in Scalyr dashboard, or false if it's user-created. */
  isBuiltIn: Scalars['Boolean'];
  /** Name of this dashboard. */
  name: Scalars['String'];
  /** Stringified version of the this dashboard's JSON options stanza. */
  options: Maybe<Scalars['String']>;
  /** Stringified JSON for the Dropdown lists of values that are shown across the top to allow filtering. */
  parameters: Maybe<Scalars['String']>;
  /** Url template of this dashboard. __SERVER_HOST__ in urlTemplate should be replaced with original host name */
  urlTemplate: Maybe<Scalars['String']>;
  /** Version of the dashboard config settings. Dashboard versions are not incremental, and is just a hash of dashboard configuration. */
  version: Scalars['Int'];
};

export type DashboardParameterInput = {
  defaultValue: InputMaybe<Scalars['String']>;
  facet: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  options: InputMaybe<Scalars['String']>;
  values: InputMaybe<Array<InputMaybe<CustomParameterValueInput>>>;
};

export type DashboardPlotQueryInput = {
  autoAlign: InputMaybe<Scalars['Boolean']>;
  breakdownFacet: InputMaybe<Scalars['String']>;
  plotIndex: InputMaybe<Scalars['Int']>;
  sliceWidth: InputMaybe<Scalars['String']>;
  slices: InputMaybe<Scalars['Int']>;
};

export type DashboardQueryGroupInput = {
  /** Active tab */
  activeTab: InputMaybe<Scalars['String']>;
  preFilter: InputMaybe<Scalars['String']>;
  queries: Array<InputMaybe<DashboardQueryInput>>;
};

export type DashboardQueryInput = {
  endTime: InputMaybe<Scalars['String']>;
  expectedExpression: InputMaybe<Scalars['String']>;
  id: InputMaybe<Scalars['String']>;
  index: Scalars['Int'];
  name: Scalars['String'];
  parameters: InputMaybe<Scalars['Map_String_StringScalar']>;
  plotQuery: InputMaybe<DashboardPlotQueryInput>;
  queryOrigin: InputMaybe<DashboardQueryOrigin>;
  startTime: InputMaybe<Scalars['String']>;
  teamEmails: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  version: InputMaybe<Scalars['Int']>;
};

export enum DashboardQueryOrigin {
  /** Queries are from the Dashboard page */
  DASHBOARD = 'DASHBOARD',
  /** Queries are from the Dashboard auto refresh page */
  DASHBOARD_AUTO_REFRESH = 'DASHBOARD_AUTO_REFRESH'
}

export type DashboardTab = {
  __typename?: 'DashboardTab';
  DEFAULT_TAB_NAME: Maybe<Scalars['String']>;
  emptyTab: Maybe<DashboardTab>;
  /** Stringified JSON for the filters in Dashboard */
  filters: Maybe<Scalars['String']>;
  /** Stringified JSON for the list of all this dashboard's visualizations, including graphs and data tables (aka reports). */
  graphs: Maybe<Scalars['String']>;
  /** Stringified version of the this dashboard's JSON options stanza. */
  options: Maybe<Scalars['String']>;
  /** Stringified JSON for the Dropdown lists of values that are shown across the top to allow filtering. */
  parameters: Maybe<Scalars['String']>;
  /** Used defined tab name if only one tab is used default tab name is used */
  tabName: Maybe<Scalars['String']>;
  /** Version of the dashboard config settings. Dashboard versions are not incremental, and is just a hash of dashboard configuration. */
  version: Scalars['Int'];
};

export type DashboardTabNameInput = {
  newName: InputMaybe<Scalars['String']>;
  originalName: InputMaybe<Scalars['String']>;
  tabToRemove: Scalars['Boolean'];
};

export enum DashboardType {
  NOT_SPECIFIED = 'NOT_SPECIFIED',
  SIMPLE = 'SIMPLE',
  TABBED = 'TABBED'
}

export type DashboardV2 = {
  __typename?: 'DashboardV2';
  /** Returns type of the config that is used for concrete dashboard. */
  configType: Maybe<DashboardType>;
  /** User-defined description of this dashboard. */
  description: Maybe<Scalars['String']>;
  /** Default timespan of this dashboard (e.g., "4h"). */
  duration: Maybe<Scalars['String']>;
  firstTab: Maybe<DashboardTab>;
  /** True if it's a built-in Scalyr dashboard, or false if it's user-created. */
  isBuiltIn: Scalars['Boolean'];
  /** Name of this dashboard. */
  name: Scalars['String'];
  /** Name of this dashboard. */
  tabs: Maybe<Array<Maybe<DashboardTab>>>;
  /** Url template of this dashboard. __SERVER_HOST__ in urlTemplate should be replaced with original host name */
  urlTemplate: Maybe<Scalars['String']>;
};

export type Data = {
  __typename?: 'Data';
  errorsData: Maybe<Array<Maybe<Scalars['Float']>>>;
  latencyData: Maybe<Array<Maybe<Scalars['Float']>>>;
  metrics: Maybe<SPMOverviewMetrics>;
  trafficData: Maybe<Array<Maybe<Scalars['Float']>>>;
};

export enum DisplayMode {
  lines = 'lines',
  table = 'table',
  wrappedLines = 'wrappedLines'
}

export type DisplaySettings = {
  __typename?: 'DisplaySettings';
  /** Additional fields specified by the user in the settings dialog. */
  additionalFields: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Display mode of search, view `DisplayMode` type for possible values. */
  displayMode: Maybe<DisplayMode>;
  /** Font to apply to the search log results */
  fontFamily: Maybe<FontFamily>;
  /** Whether or not to display the search page with the left navigation bar expanded. */
  showLeftNavExpanded: Maybe<Scalars['Boolean']>;
  /** Sort order used to display events. */
  sortOrder: Maybe<SortOrder>;
  /** System properties selected by the user in the settings dialog. */
  systemFields: Maybe<Array<Maybe<SystemField>>>;
  /** UI theme to use. */
  theme: Maybe<Theme>;
};

export type DisplaySettingsInput = {
  additionalFields: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  displayMode: InputMaybe<DisplayMode>;
  fontFamily: InputMaybe<FontFamily>;
  showLeftNavExpanded: InputMaybe<Scalars['Boolean']>;
  sortOrder: InputMaybe<SortOrder>;
  systemFields: InputMaybe<Array<InputMaybe<SystemField>>>;
  theme: InputMaybe<Theme>;
};

export type DocsData = {
  __typename?: 'DocsData';
  /** Retrieve the version information for the Scalyr Agent and repo packages. The Knob's value should be a JSON object */
  agentVersion: Maybe<AgentVersion>;
  /** Returns the value of awsAccountToTrust */
  awsAccountToTrust: Maybe<Scalars['String']>;
  /** Returns the value of awsExternalId */
  awsExternalId: Maybe<Scalars['String']>;
  /** Returns the host that is configured for this instance to receive logs */
  logsUploadHost: Maybe<Scalars['String']>;
  /** Returns the value of API token with logRead access */
  readLogsToken: Maybe<Scalars['String']>;
  /** Returns the value of API token with logWrite access */
  writeLogsToken: Maybe<Scalars['String']>;
};

export type FacetData = ResultData & {
  __typename?: 'FacetData';
  facets: Array<Maybe<FacetInfo>>;
  /** Count of events matched in this query. May be exact, but for many queries it will be approximate. For a few, for example FacetValuesQuery, it will always be 0, as there is no way to determine the match count. */
  matchCount: Scalars['Float'];
  /** Query outcome */
  outcome: Maybe<Outcome>;
  /** Start time and end time for the query in nanoseconds */
  resolvedTimeRange: LongRange;
  /** Valid only for TopFacets query response. Set to 0 for FacetValues query response. */
  sampledEventCount: Scalars['Long'];
};

export type FacetFn = {
  __typename?: 'FacetFn';
  /** Operator applied on an expression. */
  operator: Maybe<FacetOperator>;
  /** Statistical parameter to be used in conjunction with the operator. This is largely applicable for the percentile operators i.e. for p10 this param would 0.1. */
  param: Scalars['Float'];
};

export type FacetInfo = {
  __typename?: 'FacetInfo';
  /**
   * * null if FacetQuery.determineNumeric is false
   * * true if FacetQuery.determineNumeric is true, and facet has primarily numeric values
   * * false if FacetQuery.determineNumeric is true, and facet is not primarily numeric values
   *
   */
  isNumeric: Maybe<Scalars['Boolean']>;
  /** Number of events matching this facet. For top facet values queries, this is an estimate, and is the minimum of 1) the facet sample match estimate and 2) the overall sample estimate for all facets. */
  matchCount: Scalars['Float'];
  /** Facet's name. */
  name: Scalars['String'];
  /** Number of events matched in the sample. For top facet values queries, this is an estimate, computed as the sample's total estimated event match count divided by 2 * how many times the sample was reduced by half. */
  sampledMatchCount: Scalars['Float'];
  /** Number of unique values for this facet. */
  uniqueValuesCount: Scalars['Int'];
  /** Facet's values. Caridinality may be smaller than uniqueValuesCount if request constrained maximum number of values to return. */
  values: Array<Maybe<Value>>;
};

export enum FacetOperator {
  /** The number of samples in each time period */
  count = 'count',
  /** The number of samples per second (mean across each time period) */
  countPerSec = 'countPerSec',
  /** The maximum sample in each time period */
  max = 'max',
  /** The mean of all samples in each time period */
  mean = 'mean',
  /** The minimum sample in each time period */
  min = 'min',
  /** The nth percentile of all samples, `n` is supplied as the param value whose's magnitude can be anywhere between 0 and 1. */
  p = 'p',
  /** The 10th percentile of all samples in each time period */
  p10 = 'p10',
  /** The median of all samples in each time period */
  p50 = 'p50',
  /** The 90th percentile of all samples in each time period */
  p90 = 'p90',
  /** The 95th percentile of all samples in each time period */
  p95 = 'p95',
  /** The 99th percentile of all samples in each time period */
  p99 = 'p99',
  /** The 99.9th percentile of all samples in each time period */
  p999 = 'p999',
  /** The sum of all time-series in each time period */
  sum = 'sum',
  /** The sum of all time-series in each time period, divided by the number of seconds covered */
  sumPerSec = 'sumPerSec',
  /** Number of rows in a power query table */
  tableRows = 'tableRows',
  /** The single value in a 1x1 power query table */
  tableValue = 'tableValue'
}

export type FacetQueryInput = {
  determineNumeric: InputMaybe<Scalars['Boolean']>;
  includeSingleValueFacets: Scalars['Boolean'];
  numFacetsToReturn: Scalars['Int'];
  numValuesToReturnPerFacet: Scalars['Int'];
};

export type FacetValuesQueryInput = {
  determineNumeric: InputMaybe<Scalars['Boolean']>;
  name: InputMaybe<Scalars['String']>;
  numValuesToReturnForFacet: Scalars['Int'];
};

export type FeaturePermissions = {
  __typename?: 'FeaturePermissions';
  alerts: AccessLevel;
  dashboards: AccessLevel;
  labs: AccessLevel;
  logs: AccessLevel;
  privateSearches: AccessLevel;
  search: AccessLevel;
  sharedSearches: AccessLevel;
};

export enum FontFamily {
  monospace = 'monospace',
  regular = 'regular'
}

export type GenericResultData = ResultData & {
  __typename?: 'GenericResultData';
  /** Count of events matched in this query. May be exact, but for many queries it will be approximate. For a few, for example FacetValuesQuery, it will always be 0, as there is no way to determine the match count. */
  matchCount: Scalars['Float'];
  /** Query outcome */
  outcome: Maybe<Outcome>;
  /** Start time and end time for the query in nanoseconds */
  resolvedTimeRange: LongRange;
};

export type Group = {
  __typename?: 'Group';
  /** List of comma-separated dashboard names. */
  allowedDashboards: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Filter expression to restrict user search. */
  allowedSearch: Maybe<Scalars['String']>;
  /** The human-readable name of this group. */
  displayName: Scalars['String'];
  /** Unique identifier for this group. */
  id: Scalars['String'];
  /** Access level of this group. One of: limited, logRead, fullAccess. */
  permission: AccessType;
  /** Total number of members in this group. */
  totalMembers: Scalars['Int'];
};

export type HindsightDataResolver = {
  __typename?: 'HindsightDataResolver';
  /** A total number of days that the data is stored (including short term retention) */
  retentionDays: Maybe<Scalars['Int']>;
  /** A power query to show details of Hindsight searches, along with cost information for every query */
  searchCostsPowerQuery: Maybe<Scalars['String']>;
  /** A count of recent searches */
  searchCount: Maybe<Scalars['Int']>;
  /** A query to show details of Hindsight searches */
  searchDetailsQuery: Maybe<Scalars['String']>;
  /** Cost of LTR data covered by recent searches, in dollars */
  searchTotalCost: Maybe<Scalars['Float']>;
  /** Volume of LTR data covered by recent searches, in bytes */
  searchTotalVolume: Maybe<Scalars['Long']>;
  /** An average volume of long term storage over the requested period, in bytes */
  storageAverageVolume: Maybe<Scalars['Long']>;
  /** A power query to show details of Hindsight storage volume and costs */
  storageCostsPowerQuery: Maybe<Scalars['String']>;
  /** A total cost of long term storage over the requested period, in dollars */
  storageTotalCost: Maybe<Scalars['Float']>;
};

export type HistogramData = ResultData & {
  __typename?: 'HistogramData';
  /**
   * Ratio of values in a bucket.
   * e.g. 1.1 means that the bucket counts values in the range [min, min * 1.1)
   */
  bucketRatio: Maybe<Scalars['Float']>;
  /** Count of events matched in this query. May be exact, but for many queries it will be approximate. For a few, for example FacetValuesQuery, it will always be 0, as there is no way to determine the match count. */
  matchCount: Scalars['Float'];
  /** max of the samples */
  max: Maybe<Scalars['Float']>;
  /** Largest negative index required on x-axis of graph */
  maxNegative: Maybe<Scalars['Float']>;
  /** Largest positive index required on x-axis of graph */
  maxPositive: Maybe<Scalars['Float']>;
  /** mean of the samples */
  mean: Maybe<Scalars['Float']>;
  /** median of the samples */
  median: Maybe<Scalars['Float']>;
  /** min of the samples */
  min: Maybe<Scalars['Float']>;
  /** Smallest negative index required on x-axis of graph */
  minNegative: Maybe<Scalars['Float']>;
  /** Smallest positive index required on x-axis of graph */
  minPositive: Maybe<Scalars['Float']>;
  /**
   * Widths of buckets on negative x axis corresponding to each midpoint in negativeXAxis.
   * Widths need to be used only if the client is plotting the data in linear space. For log space, buckets will be of equal width
   */
  negativeBucketWidths: Maybe<Array<Maybe<Scalars['Float']>>>;
  /** Number of samples in each bucket representing negative values */
  negativeSampleCounts: Maybe<Array<Maybe<Scalars['Float']>>>;
  /** Plots on negative axis corresponding to each bucket in negativeSampleCounts */
  negativeXAxis: Maybe<Array<Maybe<Scalars['Float']>>>;
  /** Query outcome */
  outcome: Maybe<Outcome>;
  /** p10 of the samples */
  p10: Maybe<Scalars['Float']>;
  /** p90 of the samples */
  p90: Maybe<Scalars['Float']>;
  /** p99 of the samples */
  p99: Maybe<Scalars['Float']>;
  /** p999 of the samples */
  p999: Maybe<Scalars['Float']>;
  /**
   * Widths of buckets on positive x axis corresponding to each midpoint in positiveXAxis.
   * Widths need to be used only if the client is plotting the data in linear space. For log space, buckets will be of equal width
   */
  positiveBucketWidths: Maybe<Array<Maybe<Scalars['Float']>>>;
  /** Number of samples in each bucket representing positive values */
  positiveSampleCounts: Maybe<Array<Maybe<Scalars['Float']>>>;
  /** Plots on positive axis corresponding to each bucket in positiveSampleCounts */
  positiveXAxis: Maybe<Array<Maybe<Scalars['Float']>>>;
  /** Start time and end time for the query in nanoseconds */
  resolvedTimeRange: LongRange;
  /** Number of samples representing zero values */
  zeroCount: Maybe<Scalars['Float']>;
};

export type Host = {
  __typename?: 'Host';
  attributes: Maybe<Scalars['Map_String_StringScalar']>;
  dashboards: Maybe<Array<Maybe<DashboardOld>>>;
  ipAddress: Maybe<Scalars['String']>;
  logFiles: Maybe<Array<Maybe<Scalars['String']>>>;
  name: Maybe<Scalars['String']>;
};

export type ImageFileInput = {
  base64Image: Scalars['String'];
  fileName: Scalars['String'];
  fileType: Scalars['String'];
};

export type InviteLinkToken = {
  __typename?: 'InviteLinkToken';
  invitee: Maybe<Scalars['String']>;
  linkAccountActionType: Maybe<LinkAccountActionType>;
  target: Maybe<Scalars['String']>;
};

export type Key = {
  __typename?: 'Key';
  /** Key access level. */
  access: Access;
  /** Date this api key expires in ISO 8601 UTC format. */
  expiration: Scalars['String'];
  /** If true, key is hidden */
  hidden: Scalars['Boolean'];
  /** Identifier for this api key. */
  id: Scalars['String'];
  /** Key label. */
  label: Scalars['String'];
  /** Key type. */
  type: Type;
  /** Value for this api key. */
  value: Scalars['String'];
};

export type KubeCluster = {
  __typename?: 'KubeCluster';
  controllers: Array<KubeController>;
  dashboard: Maybe<Dashboard>;
  name: Scalars['String'];
};

export type KubeController = {
  __typename?: 'KubeController';
  kind: Scalars['String'];
  labels: Maybe<Scalars['String']>;
  name: Scalars['String'];
  pods: Array<KubePod>;
};

export type KubePod = {
  __typename?: 'KubePod';
  name: Maybe<Scalars['String']>;
};

export type Lab = Node & {
  __typename?: 'Lab';
  /** Engineer contact in Scalyr for this lab */
  author: Maybe<Scalars['String']>;
  /** Description for the lab */
  description: Maybe<Scalars['String']>;
  /** Is the lab enabled by user. */
  enabled: Scalars['Boolean'];
  /** ID of the lab. */
  id: Scalars['ID'];
  /** Link to image representing the lab */
  imageSrc: Maybe<Scalars['String']>;
  /** Name of the lab. */
  name: Scalars['String'];
  /** Is the lab required by Scalyr. */
  required: Scalars['Boolean'];
  /** Title of the lab */
  title: Maybe<Scalars['String']>;
};

export enum LinkAccountActionType {
  /** Invite link for non-existing account. */
  CREATE = 'CREATE',
  /** Invite link for existing account. */
  LINK = 'LINK'
}

export type LiveTail = {
  __typename?: 'LiveTail';
  /** Return a list of current logs */
  getLogEntries: Array<Maybe<LogEntryEdge>>;
};


export type LiveTailgetLogEntriesArgs = {
  liveTailRequest: LiveTailRequestInput;
};

export type LiveTailRequestInput = {
  filter: Scalars['String'];
  maxResults: Scalars['Int'];
};

export type LogEntry = {
  __typename?: 'LogEntry';
  /** True if number of facets exceeded the provided limit */
  facetsNumberLimitExceeded: Scalars['Boolean'];
  /** List of facets whose values were truncated due to exceeding provided length limit */
  facetsWithTruncatedValues: Array<Scalars['String']>;
  parentTimestamps: Array<Scalars['Long']>;
  /** Collection of fields derived from configurations. */
  serverInfo: Scalars['Map_String_ObjectScalar'];
  sessionId: Scalars['String'];
  severity: Scalars['Int'];
  threadId: Scalars['String'];
  /** Nanosecond timestamp when the event occurred. */
  timestamp: Scalars['Long'];
  type: RepoEventType;
  /** Collection of fields derived from the log event. */
  values: Scalars['Map_String_ObjectScalar'];
};

export type LogEntryData = ResultData & {
  __typename?: 'LogEntryData';
  /** No newer events could be found for this query. */
  isAtEnd: Scalars['Boolean'];
  /** No older events could be found for this query. */
  isAtStart: Scalars['Boolean'];
  /** Count of events matched in this query. May be exact, but for many queries it will be approximate. For a few, for example FacetValuesQuery, it will always be 0, as there is no way to determine the match count. */
  matchCount: Scalars['Float'];
  /** The list of log entries that matched this query. */
  matches: Array<Maybe<LogEntryEdge>>;
  /** Query outcome */
  outcome: Maybe<Outcome>;
  /** Start time and end time for the query in nanoseconds */
  resolvedTimeRange: LongRange;
};

export type LogEntryEdge = {
  __typename?: 'LogEntryEdge';
  /** Unique identifier for cursor-based pagination. */
  continuationToken: Scalars['String'];
  /** A log event. */
  logEntry: LogEntry;
};

export type LogEntryEdgeResult = {
  __typename?: 'LogEntryEdgeResult';
  /** errorString */
  errorString: Maybe<Scalars['String']>;
  /** A log event. */
  logEntry: LogEntryEdge;
  /** outcome */
  outcome: Maybe<Outcome>;
};

export enum LogLevel {
  ERROR = 'ERROR',
  INFO = 'INFO',
  WARN = 'WARN'
}

export type LogToScalyrInput = {
  level: LogLevel;
  message: Scalars['String'];
  type: LogType;
};

export enum LogType {
  /** Message if in Json format, will the parsed and logged to Scalyr. */
  JSON = 'JSON',
  /** [Currently not supported] Message if in Opencensus format, will the parsed and logged to Scalyr. */
  OPENCENSUS = 'OPENCENSUS',
  /** Message will be logged to Scalyr without parsing. */
  STRING = 'STRING'
}

export type LongRange = {
  __typename?: 'LongRange';
  /** max long range */
  max: Scalars['Long'];
  /** min long range */
  min: Scalars['Long'];
};

export type ManagementTag = {
  __typename?: 'ManagementTag';
  allowEdit: Scalars['Boolean'];
  assignedAt: Maybe<Scalars['String']>;
  assignedBy: Maybe<Scalars['String']>;
  assignedById: Maybe<Scalars['String']>;
  assignmentMethod: Maybe<S1TagAssignmentMethod>;
  description: Maybe<Scalars['String']>;
  endpointsCurrentScope: Maybe<Scalars['String']>;
  endpointsCurrentTotal: Maybe<Scalars['String']>;
  id: Maybe<Scalars['String']>;
  key: Maybe<Scalars['String']>;
  scopeId: Maybe<Scalars['String']>;
  scopeLevel: Maybe<S1ManagementScope>;
  type: Maybe<S1TagType>;
  updatedAt: Maybe<Scalars['String']>;
  updatedBy: Maybe<Scalars['String']>;
  value: Maybe<Scalars['String']>;
};

/** Mutation root */
export type Mutation = {
  __typename?: 'Mutation';
  /** Accept invite link. */
  acceptInvite: Scalars['Boolean'];
  /** Accept invite link. */
  acceptInviteLink: Scalars['Boolean'];
  addAnnotation: Maybe<Annotation>;
  /** Add configuration file. */
  addConfigFile: Maybe<ConfigFile>;
  /** Add a new dashboard filter */
  addDashboardFilter: Maybe<Dashboard>;
  /** Add a new dashboard parameter */
  addDashboardParam: Maybe<Dashboard>;
  /** Append a graph to a dashboard. If the dashboard does not exist, a new dashboard is created and the graph is added to it. */
  addGraphToDashboard: Maybe<Dashboard>;
  /** Add export job */
  addJob: Maybe<BulkExport>;
  /** Save parser file. */
  addParser: Maybe<Parser>;
  /** Creates, validates and persists a new scrubbing rule. */
  addScrubbingRule: ScrubbingRuleRequestBody;
  /** Set array of dashboard tabs for concrete dashboard. Order is defined in array. Tab rename is also possible though this API, but original name needs to be specified as well */
  arrangeTabsOrderAndNames: Maybe<Scalars['Boolean']>;
  /** Cancel export job */
  cancelJob: Maybe<BulkExport>;
  /** Change password of the user */
  changePassword: Maybe<Scalars['Boolean']>;
  /** Compress a URL and return its shortened version. */
  compressUrl: Maybe<Scalars['String']>;
  /** Create new alert for this account. The maximum number of alert entries  for a given account is determined by keyed knob maxEntriesPerAccount */
  createAlert: Maybe<AlertInfo>;
  /** Create budget category */
  createBudgetCategory: Maybe<BudgetCategory>;
  /** Create new dashboard */
  createDashboard: Dashboard;
  /** Create new dashboard */
  createDashboardV2: DashboardV2;
  /** Create budget category discard filter */
  createFilter: Maybe<BudgetCategoryDiscardFilter>;
  /** Add new api key. */
  createKey: Key;
  /** Create a new customer secret. */
  createSecret: Maybe<Secret>;
  /** Delete an already existing alert for this account */
  deleteAlert: Maybe<Scalars['String']>;
  /** Delete a set of already existing alert for this account */
  deleteAlerts: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Delete budget category */
  deleteBudgetCategory: Maybe<BudgetCategory>;
  /** Delete configuration file. */
  deleteConfigFile: Maybe<ConfigFile>;
  /** Delete existing dashboard */
  deleteDashboard: Scalars['Boolean'];
  /** Delete a dashboard filter */
  deleteDashboardFilter: Maybe<Dashboard>;
  /** Delete a dashboard graph. */
  deleteDashboardGraph: Maybe<Dashboard>;
  /** Delete a dashboard parameter */
  deleteDashboardParam: Maybe<Dashboard>;
  /** Delete budget category discard filter */
  deleteFilter: Maybe<BudgetCategoryDiscardFilter>;
  /** Delete api key with the specified id. */
  deleteKey: Key;
  /**
   * Deletes a saved searches from the account.
   * @deprecated Deprecated in favour of deleteSavedSearchV2
   */
  deleteSavedSearch: Maybe<SavedSearch>;
  /** Deletes a saved searches from the account. */
  deleteSavedSearchV2: Maybe<Array<Maybe<SavedSearch>>>;
  /** Deletes provided `rule` from the data store. */
  deleteScrubbingRule: Scalars['Boolean'];
  /** Remove a secret by name. */
  deleteSecret: Maybe<Secret>;
  /** Delete user's selected slack channel. */
  deleteSlackChannel: SlackChannelInfo;
  /** Edit existing dashboard config. */
  editDashboard: Maybe<Dashboard>;
  /** Edit dashboard filter */
  editDashboardFilter: Maybe<Dashboard>;
  /** Edit dashboard graph. */
  editDashboardGraph: Maybe<Dashboard>;
  /** Edit dashboard parameter */
  editDashboardParam: Maybe<Dashboard>;
  /** Edit existing dashboard config. */
  editDashboardV2: Maybe<DashboardV2>;
  /** Allows to edit permission attributes of a group. */
  editGroupPermissions: Group;
  /** Encrypt a value */
  encryptSecretValue: Maybe<Scalars['String']>;
  /** Formats configuration file content to pretty printed json. */
  formatConfigFile: Maybe<Scalars['String']>;
  /** Formats parser content. */
  formatParser: Maybe<Scalars['String']>;
  /** Returns just partial json for concrete tab specified by dashboardName and tabName. */
  getDashboardTabConfig: Maybe<Scalars['String']>;
  /** Change the currently active account for the user and return the new active account's email address. */
  linkAccount: Maybe<AccountData>;
  /** Messages logged using this mutation are used by Scalyr for internal debugging. It is, therefore, not a replacement for uploadLogs or addEvents apis. Returns true if all messages were logged without rate limiting. */
  logToScalyr: Maybe<Scalars['Boolean']>;
  /** Creates a demo login session id and returns it in the response */
  loginToDemoAccount: Maybe<Scalars['String']>;
  loginWithPassword: Maybe<Scalars['Boolean']>;
  /**
   * Log user in using Single Sign-On
   * @deprecated To be replaced with /v2/sso/login
   */
  loginWithSso: Maybe<Scalars['Boolean']>;
  /** Logs out from current session. */
  logout: Maybe<Scalars['Boolean']>;
  /** Move budget category */
  moveBudgetCategory: Maybe<BudgetCategory>;
  /** Moves graph from one tab to another by giving dashboardName, sourceTabName and index of widget in graphs array in destination graphs array. The widgets appears as the last one in the destinationTab. */
  moveGraphBetweenDashboardTabs: Maybe<Scalars['Boolean']>;
  /** Moves provided `rule` to specified position in the list of scrubbing rules. */
  moveScrubbingRule: ScrubbingRuleRequestBody;
  /** Remove a query. */
  removeQuery: Scalars['Boolean'];
  /** Create custom-build parser. */
  requestCustomParser: Maybe<Scalars['Boolean']>;
  /** Send a verify-email-address messages to the given user, and return true. If the user's address was already confirmed, do nothing and return false. */
  requestEmailConfirmation: Maybe<Scalars['Boolean']>;
  /** Request password reset. */
  requestPasswordReset: Scalars['Boolean'];
  /** Resend invite by email */
  resendInvite: Scalars['Boolean'];
  /** Reset password. */
  resetPassword: Scalars['Boolean'];
  /** Reverts parser. */
  revertParser: Maybe<Scalars['Boolean']>;
  /** Revoke access by email */
  revokeAccess: Maybe<Scalars['Boolean']>;
  /** Revoke invite by email */
  revokeInvite: Scalars['Boolean'];
  /** Updates the preferences API in mgmt console with a randomly generated UUID as the identifier for the action and saves its context as the payload */
  s1CreateConsoleAction: Maybe<Scalars['String']>;
  /** Calls the given actionPath with the provided data and filter as payload and returns the output */
  s1PerformGenericAgentAction: Maybe<S1GenericAgentActionResponse>;
  /** Replace a dashboard's layout settings from the client to persist the overall layout. */
  saveDashboardLayout: Maybe<Dashboard>;
  /** Add the results of the query to a new or existing dashboard as a report. */
  savePowerQueryToDashboard: Maybe<Scalars['Boolean']>;
  /**
   * Save search for the account.
   * @deprecated Deprecated in favour of saveSearchV2
   */
  saveSearch: Scalars['Boolean'];
  /** Save search for the account. */
  saveSearchV2: Array<Maybe<SavedSearch>>;
  /** Send invites to users by email with granted access to owner's dashboards */
  sendInvite: Array<Maybe<UserAccount>>;
  /** Update the given user's usage plan to the specified flex plan. */
  setAccountFlexPlan: Maybe<Scalars['Boolean']>;
  /** Sets display settings with the provided properties. */
  setDisplaySettings: Maybe<DisplaySettings>;
  /** Store slack user's access token, userId, and userName in Preferences. If a channel is selected, this will also store the channel info. */
  signInToSlack: Scalars['Boolean'];
  signUpWithLoginAndPassword: Maybe<Scalars['Boolean']>;
  /** Silence an already existing alert for this account */
  silenceAlerts: Maybe<Scalars['Boolean']>;
  /** Tests parser for given test data. */
  testParser: Maybe<Parser>;
  /** Enable/Disable Lab. Required labs cannot be toggled with this operation */
  toggleLab: Maybe<Lab>;
  /** Make an alert active and remove any silences added to alerts */
  unSilenceAlerts: Maybe<Scalars['Boolean']>;
  /** Update an existing alert for this account */
  updateAlert: Maybe<AlertInfo>;
  /** Update budget category */
  updateBudgetCategory: Maybe<BudgetCategory>;
  /** Either creates or updates a budget category notification. */
  updateBudgetNotification: Maybe<BudgetNotification>;
  /** Updates credit card info for the user. */
  updateCreditCard: Maybe<Scalars['Boolean']>;
  /** Stores content of just one Dashboard tab. */
  updateDashboardTabConfig: Maybe<Scalars['Boolean']>;
  /** Update budget category discard filter */
  updateFilter: Maybe<BudgetCategoryDiscardFilter>;
  /** Update an api key. */
  updateKey: Key;
  /** Updates overage notification settings. */
  updateOverageNotificationSettings: Maybe<OverageNotificationSettings>;
  /** Update parser sample. */
  updateParserSample: Maybe<Parser>;
  /** Updates the supplied user preferences. Only the supplied preferences are updated and rest are unaffected. To reset a preference to its default value, set its value to null. */
  updatePreferences: Maybe<UserPreferences>;
  /** Updates provided `rule` in the data store. */
  updateScrubbingRule: ScrubbingRuleRequestBody;
  /** Update an existing customer secret. */
  updateSecret: Maybe<Secret>;
  /** Update an existing customer secret description. */
  updateSecretDescription: Maybe<Secret>;
  /** Updates human-readable name of a team. The user must have owner permission for the team. */
  updateTeamName: Maybe<TeamData>;
  /** Uploads given image to specified channels. */
  uploadImageToSlackChannels: Scalars['Boolean'];
  /** Validate password reset token and return email if its valid. */
  validateResetPasswordToken: Maybe<Scalars['String']>;
  /** Verify token for email verification. */
  verifyEmail: Scalars['Boolean'];
};


/** Mutation root */
export type MutationacceptInviteArgs = {
  token: Scalars['String'];
};


/** Mutation root */
export type MutationacceptInviteLinkArgs = {
  password: Scalars['String'];
  token: Scalars['String'];
};


/** Mutation root */
export type MutationaddAnnotationArgs = {
  annotation: AnnotationRequestInput;
};


/** Mutation root */
export type MutationaddConfigFileArgs = {
  content: InputMaybe<Scalars['String']>;
  name: InputMaybe<Scalars['String']>;
};


/** Mutation root */
export type MutationaddDashboardFilterArgs = {
  dashboardName: Scalars['String'];
  filter: DashboardFilterInput;
  tabName?: InputMaybe<Scalars['String']>;
};


/** Mutation root */
export type MutationaddDashboardParamArgs = {
  dashboardName: Scalars['String'];
  newDashboardParameter: DashboardParameterInput;
  tabName: Scalars['String'];
};


/** Mutation root */
export type MutationaddGraphToDashboardArgs = {
  dashboardName: Scalars['String'];
  graph: Scalars['String'];
  tabName?: InputMaybe<Scalars['String']>;
};


/** Mutation root */
export type MutationaddJobArgs = {
  job: InputMaybe<BulkExportRequestInput>;
};


/** Mutation root */
export type MutationaddParserArgs = {
  parserName: Scalars['String'];
  textContent: InputMaybe<Scalars['String']>;
};


/** Mutation root */
export type MutationaddScrubbingRuleArgs = {
  scrubbingRule: ScrubbingRuleRequestBodyInput;
};


/** Mutation root */
export type MutationarrangeTabsOrderAndNamesArgs = {
  dashboardName: Scalars['String'];
  tabs: Array<InputMaybe<DashboardTabNameInput>>;
};


/** Mutation root */
export type MutationcancelJobArgs = {
  jobId: InputMaybe<Scalars['String']>;
};


/** Mutation root */
export type MutationchangePasswordArgs = {
  currentPassword: InputMaybe<Scalars['String']>;
  newPassword: InputMaybe<Scalars['String']>;
  timezone: InputMaybe<Scalars['Int']>;
};


/** Mutation root */
export type MutationcompressUrlArgs = {
  sourceUrl: Scalars['String'];
};


/** Mutation root */
export type MutationcreateAlertArgs = {
  alert: AlertInput;
};


/** Mutation root */
export type MutationcreateBudgetCategoryArgs = {
  budgetCategoryRequest: BudgetCategoryRequestInput;
};


/** Mutation root */
export type MutationcreateDashboardArgs = {
  config: InputMaybe<Scalars['String']>;
  dashboardName: Scalars['String'];
};


/** Mutation root */
export type MutationcreateDashboardV2Args = {
  config: InputMaybe<Scalars['String']>;
  dashboardName: Scalars['String'];
};


/** Mutation root */
export type MutationcreateFilterArgs = {
  categoryId: Scalars['ID'];
  filterRequest: BudgetCategoryDiscardFilterRequestInput;
};


/** Mutation root */
export type MutationcreateKeyArgs = {
  access: Access;
  label: InputMaybe<Scalars['String']>;
  type: Type;
};


/** Mutation root */
export type MutationcreateSecretArgs = {
  description: InputMaybe<Scalars['String']>;
  name: Scalars['ID'];
  secretValue: Scalars['String'];
};


/** Mutation root */
export type MutationdeleteAlertArgs = {
  id: Scalars['String'];
};


/** Mutation root */
export type MutationdeleteAlertsArgs = {
  ids: InputMaybe<Array<Scalars['String']>>;
};


/** Mutation root */
export type MutationdeleteBudgetCategoryArgs = {
  id: Scalars['ID'];
};


/** Mutation root */
export type MutationdeleteConfigFileArgs = {
  id: InputMaybe<Scalars['ID']>;
};


/** Mutation root */
export type MutationdeleteDashboardArgs = {
  dashboardName: Scalars['String'];
};


/** Mutation root */
export type MutationdeleteDashboardFilterArgs = {
  dashboardName: Scalars['String'];
  filterIndex: Scalars['Int'];
  tabName?: InputMaybe<Scalars['String']>;
};


/** Mutation root */
export type MutationdeleteDashboardGraphArgs = {
  dashboardName: Scalars['String'];
  graphIndex: Scalars['Int'];
  tabName?: InputMaybe<Scalars['String']>;
};


/** Mutation root */
export type MutationdeleteDashboardParamArgs = {
  dashboardName: Scalars['String'];
  paramIndex: Scalars['Int'];
  tabName: Scalars['String'];
};


/** Mutation root */
export type MutationdeleteFilterArgs = {
  categoryId: Scalars['Int'];
  filterId: Scalars['ID'];
};


/** Mutation root */
export type MutationdeleteKeyArgs = {
  id: Scalars['String'];
};


/** Mutation root */
export type MutationdeleteSavedSearchArgs = {
  index: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  type: InputMaybe<SavedSearchType>;
};


/** Mutation root */
export type MutationdeleteSavedSearchV2Args = {
  index: Scalars['Int'];
  name: Scalars['String'];
  type: SavedSearchType;
};


/** Mutation root */
export type MutationdeleteScrubbingRuleArgs = {
  id: Scalars['ID'];
};


/** Mutation root */
export type MutationdeleteSecretArgs = {
  name: Scalars['ID'];
};


/** Mutation root */
export type MutationdeleteSlackChannelArgs = {
  channelInfo: SlackChannelInfoInput;
};


/** Mutation root */
export type MutationeditDashboardArgs = {
  dashboardName: Scalars['String'];
  description: InputMaybe<Scalars['String']>;
  duration: InputMaybe<Scalars['String']>;
  newName: InputMaybe<Scalars['String']>;
};


/** Mutation root */
export type MutationeditDashboardFilterArgs = {
  dashboardName: Scalars['String'];
  filter: DashboardFilterInput;
  filterIndex: Scalars['Int'];
  tabName?: InputMaybe<Scalars['String']>;
};


/** Mutation root */
export type MutationeditDashboardGraphArgs = {
  dashboardName: Scalars['String'];
  graph: Scalars['String'];
  graphIndex: Scalars['Int'];
  layout: InputMaybe<Scalars['String']>;
  tabName?: InputMaybe<Scalars['String']>;
};


/** Mutation root */
export type MutationeditDashboardParamArgs = {
  dashboardName: Scalars['String'];
  newDashboardParameter: DashboardParameterInput;
  paramIndex: Scalars['Int'];
  tabName: Scalars['String'];
};


/** Mutation root */
export type MutationeditDashboardV2Args = {
  dashboardName: Scalars['String'];
  description: InputMaybe<Scalars['String']>;
  duration: InputMaybe<Scalars['String']>;
  newName: InputMaybe<Scalars['String']>;
  tabName?: InputMaybe<Scalars['String']>;
};


/** Mutation root */
export type MutationeditGroupPermissionsArgs = {
  allowedDashboards: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  allowedSearch: InputMaybe<Scalars['String']>;
  groupId: Scalars['String'];
  permission: InputMaybe<AccessType>;
};


/** Mutation root */
export type MutationencryptSecretValueArgs = {
  value: Scalars['String'];
};


/** Mutation root */
export type MutationformatConfigFileArgs = {
  content: Scalars['String'];
  id: Scalars['ID'];
};


/** Mutation root */
export type MutationformatParserArgs = {
  content: Scalars['String'];
  id: Scalars['ID'];
};


/** Mutation root */
export type MutationgetDashboardTabConfigArgs = {
  dashboardName: Scalars['String'];
  tabName: Scalars['String'];
};


/** Mutation root */
export type MutationlinkAccountArgs = {
  password: InputMaybe<Scalars['String']>;
  targetAccountEmail: Scalars['String'];
};


/** Mutation root */
export type MutationlogToScalyrArgs = {
  logToScalyrInputs: InputMaybe<Array<InputMaybe<LogToScalyrInput>>>;
};


/** Mutation root */
export type MutationloginToDemoAccountArgs = {
  timezoneOffset: Scalars['String'];
};


/** Mutation root */
export type MutationloginWithPasswordArgs = {
  email: Scalars['String'];
  password: Scalars['String'];
  rememberMe: Scalars['Boolean'];
  timezoneOffset: Scalars['Int'];
};


/** Mutation root */
export type MutationloginWithSsoArgs = {
  email: Scalars['String'];
  originalUrl: InputMaybe<Scalars['String']>;
};


/** Mutation root */
export type MutationmoveBudgetCategoryArgs = {
  id: Scalars['ID'];
  position: Scalars['Int'];
};


/** Mutation root */
export type MutationmoveGraphBetweenDashboardTabsArgs = {
  dashboardName: Scalars['String'];
  destinationTabName: Scalars['String'];
  graphIndex: Scalars['Int'];
  sourceTabName: Scalars['String'];
};


/** Mutation root */
export type MutationmoveScrubbingRuleArgs = {
  id: Scalars['ID'];
  position: Scalars['Int'];
};


/** Mutation root */
export type MutationremoveQueryArgs = {
  token: Scalars['String'];
};


/** Mutation root */
export type MutationrequestCustomParserArgs = {
  comments: Scalars['String'];
  id: Scalars['ID'];
};


/** Mutation root */
export type MutationrequestPasswordResetArgs = {
  email: Scalars['String'];
};


/** Mutation root */
export type MutationresendInviteArgs = {
  email: Scalars['String'];
};


/** Mutation root */
export type MutationresetPasswordArgs = {
  password: Scalars['String'];
  timezoneOffset: InputMaybe<Scalars['String']>;
  token: Scalars['String'];
  userId: Scalars['String'];
};


/** Mutation root */
export type MutationrevertParserArgs = {
  id: Scalars['ID'];
};


/** Mutation root */
export type MutationrevokeAccessArgs = {
  email: InputMaybe<Scalars['String']>;
};


/** Mutation root */
export type MutationrevokeInviteArgs = {
  email: Scalars['String'];
};


/** Mutation root */
export type Mutations1CreateConsoleActionArgs = {
  actionContext: InputMaybe<Scalars['String']>;
  managementConsoleUrl: InputMaybe<Scalars['String']>;
};


/** Mutation root */
export type Mutations1PerformGenericAgentActionArgs = {
  actionPath: InputMaybe<Scalars['String']>;
  data: InputMaybe<Scalars['String']>;
  filter: InputMaybe<Scalars['String']>;
  managementConsoleUrl: InputMaybe<Scalars['String']>;
};


/** Mutation root */
export type MutationsaveDashboardLayoutArgs = {
  dashboardName: Scalars['String'];
  graphs: InputMaybe<Scalars['String']>;
  options: InputMaybe<Scalars['String']>;
  tabName?: InputMaybe<Scalars['String']>;
};


/** Mutation root */
export type MutationsavePowerQueryToDashboardArgs = {
  dashboardName: InputMaybe<Scalars['String']>;
  graphTitle: InputMaybe<Scalars['String']>;
  query: InputMaybe<Scalars['String']>;
  tabName?: InputMaybe<Scalars['String']>;
};


/** Mutation root */
export type MutationsaveSearchArgs = {
  name: Scalars['String'];
  type: SavedSearchType;
  url: Scalars['String'];
};


/** Mutation root */
export type MutationsaveSearchV2Args = {
  name: Scalars['String'];
  type: SavedSearchType;
  url: Scalars['String'];
};


/** Mutation root */
export type MutationsendInviteArgs = {
  access: InputMaybe<AccessType>;
  allowedDashboards: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  allowedSearch: InputMaybe<Scalars['String']>;
  emails: Array<InputMaybe<Scalars['String']>>;
};


/** Mutation root */
export type MutationsetAccountFlexPlanArgs = {
  dailyGb: Scalars['Int'];
  retentionDays: Scalars['Int'];
};


/** Mutation root */
export type MutationsetDisplaySettingsArgs = {
  scope: InputMaybe<Scope>;
  settings: InputMaybe<DisplaySettingsInput>;
};


/** Mutation root */
export type MutationsignInToSlackArgs = {
  code: Scalars['String'];
};


/** Mutation root */
export type MutationsignUpWithLoginAndPasswordArgs = {
  clientTimeZoneOffset: Scalars['String'];
  emailAddress: Scalars['String'];
  password: Scalars['String'];
};


/** Mutation root */
export type MutationsilenceAlertsArgs = {
  silenceComment: InputMaybe<Scalars['String']>;
  silenceConditions: InputMaybe<Array<SilenceConditionInput>>;
  silenceUntil: Scalars['String'];
};


/** Mutation root */
export type MutationtestParserArgs = {
  showDetailedOutput: Scalars['Boolean'];
  testData: Scalars['String'];
  textContent: Scalars['String'];
};


/** Mutation root */
export type MutationtoggleLabArgs = {
  enable: Scalars['Boolean'];
  name: InputMaybe<Scalars['String']>;
};


/** Mutation root */
export type MutationunSilenceAlertsArgs = {
  ids: InputMaybe<Array<Scalars['String']>>;
};


/** Mutation root */
export type MutationupdateAlertArgs = {
  alert: AlertInput;
  id: Scalars['String'];
};


/** Mutation root */
export type MutationupdateBudgetCategoryArgs = {
  budgetCategoryRequest: BudgetCategoryRequestInput;
  id: Scalars['ID'];
};


/** Mutation root */
export type MutationupdateBudgetNotificationArgs = {
  budgetNotificationRequest: InputMaybe<BudgetNotificationRequestInput>;
};


/** Mutation root */
export type MutationupdateCreditCardArgs = {
  billingInformation: BillingInformationInput;
  stripeToken: Scalars['String'];
};


/** Mutation root */
export type MutationupdateDashboardTabConfigArgs = {
  dashboardName: Scalars['String'];
  tabContent: Scalars['String'];
  tabName: Scalars['String'];
};


/** Mutation root */
export type MutationupdateFilterArgs = {
  categoryId: Scalars['Int'];
  filterId: Scalars['ID'];
  filterRequest: BudgetCategoryDiscardFilterRequestInput;
};


/** Mutation root */
export type MutationupdateKeyArgs = {
  id: Scalars['String'];
  label: Scalars['String'];
};


/** Mutation root */
export type MutationupdateOverageNotificationSettingsArgs = {
  overageNotificationSettingsRequest: InputMaybe<OverageNotificationSettingsRequestInput>;
};


/** Mutation root */
export type MutationupdateParserSampleArgs = {
  filter: Scalars['String'];
  id: Scalars['ID'];
};


/** Mutation root */
export type MutationupdatePreferencesArgs = {
  homepages: InputMaybe<Array<InputMaybe<PreferenceHomepageInput>>>;
  timezone: InputMaybe<Scalars['String']>;
};


/** Mutation root */
export type MutationupdateScrubbingRuleArgs = {
  id: Scalars['ID'];
  scrubbingRule: ScrubbingRuleRequestBodyInput;
};


/** Mutation root */
export type MutationupdateSecretArgs = {
  description: InputMaybe<Scalars['String']>;
  name: Scalars['ID'];
  secretValue: InputMaybe<Scalars['String']>;
};


/** Mutation root */
export type MutationupdateSecretDescriptionArgs = {
  description: InputMaybe<Scalars['String']>;
  name: Scalars['ID'];
};


/** Mutation root */
export type MutationupdateTeamNameArgs = {
  name: Scalars['String'];
  teamId: Scalars['String'];
};


/** Mutation root */
export type MutationuploadImageToSlackChannelsArgs = {
  channelIds: Array<InputMaybe<Scalars['String']>>;
  image: ImageFileInput;
  initialComment: Scalars['String'];
};


/** Mutation root */
export type MutationvalidateResetPasswordTokenArgs = {
  token: Scalars['String'];
  userId: Scalars['String'];
};


/** Mutation root */
export type MutationverifyEmailArgs = {
  token: Scalars['String'];
};

/** An object with an ID */
export type Node = {
  /** The ID of an object */
  id: Scalars['ID'];
};

export enum Outcome {
  ERROR = 'ERROR',
  OK = 'OK',
  TIMEOUT = 'TIMEOUT'
}

export enum Output {
  JSON = 'JSON',
  PLAIN_TEXT = 'PLAIN_TEXT'
}

export type OverageNotificationSettings = {
  __typename?: 'OverageNotificationSettings';
  dailyThresholdGib: Scalars['Float'];
  /** Daily threshold as a percentage of a plan */
  dailyThresholdPercent: Maybe<Scalars['Float']>;
  /** Is notification disabled. */
  disabled: Scalars['Boolean'];
  /** Recipients of the notification. */
  emails: Array<Maybe<Scalars['String']>>;
};

export type OverageNotificationSettingsRequestInput = {
  disabled: Scalars['Boolean'];
  emails: Array<InputMaybe<Scalars['String']>>;
  threshold: InputMaybe<Scalars['Float']>;
  thresholdPercent: InputMaybe<Scalars['Float']>;
};

export type PaginationDetails = {
  __typename?: 'PaginationDetails';
  nextCursor: Maybe<Scalars['String']>;
  totalItems: Scalars['Int'];
};

export type ParsedExpression = {
  __typename?: 'ParsedExpression';
  /** Property being queried for this expression. */
  facet: Maybe<Scalars['String']>;
  /** Raw filter for this expression. */
  filter: Maybe<Scalars['String']>;
  /** Function applied to this expression when evaluating. */
  fn: Maybe<FacetFn>;
};

export type ParsedPowerQueryExpression = {
  __typename?: 'ParsedPowerQueryExpression';
  /** Function applied to this expression when evaluating. */
  fn: Maybe<FacetFn>;
  /** Raw powerQuery for this expression. */
  powerQuery: Maybe<Scalars['String']>;
};

export type Parser = {
  __typename?: 'Parser';
  /** String of the parser content. */
  content: Maybe<Scalars['String']>;
  /** Filter errors in log sample the parser. */
  filterErrors: Maybe<Scalars['String']>;
  /** Id of the parser. Duplicates 'name' field */
  id: Maybe<Scalars['ID']>;
  /** String of the full log. */
  log: Maybe<Scalars['String']>;
  /** Number of logs. */
  logCount: Maybe<Scalars['Int']>;
  /** Log sample of the parser. */
  logSample: Maybe<Array<Maybe<Scalars['String']>>>;
  /** List of first 10 logs to show. */
  logs: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Name of the parser. */
  name: Maybe<Scalars['String']>;
  /** Type of the parser. */
  type: Maybe<ParserType>;
};

export enum ParserType {
  BUILT_IN = 'BUILT_IN',
  BUILT_IN_CUSTOM = 'BUILT_IN_CUSTOM',
  CUSTOM = 'CUSTOM',
  UNDEFINED = 'UNDEFINED'
}

export enum Permission {
  configRead = 'configRead',
  configWrite = 'configWrite',
  fullAccess = 'fullAccess',
  limited = 'limited',
  logRead = 'logRead',
  logWrite = 'logWrite',
  manageApiKeys = 'manageApiKeys',
  master = 'master',
  owner = 'owner',
  userConfigWrite = 'userConfigWrite',
  xdrUser = 'xdrUser'
}

export type PlanData = {
  __typename?: 'PlanData';
  /** Gigabytes per day */
  gbPerDay: Scalars['Long'];
  /** Price per month */
  price: Scalars['Float'];
  /** Number of days to keep logs */
  retention: Scalars['Int'];
};

export type Plot = {
  __typename?: 'Plot';
  /** Aggregation function applied on the expression supplied by the plot query. */
  fn: Maybe<FacetFn>;
  /** Label representing plot information */
  label: Maybe<Scalars['String']>;
  /** Y axis data points for this plot. */
  samples: Maybe<Array<Maybe<Scalars['Float']>>>;
  /** Total of the sample data. */
  total: Scalars['Float'];
};

export type PlotData = ResultData & {
  __typename?: 'PlotData';
  /** Count of events matched in this query. May be exact, but for many queries it will be approximate. For a few, for example FacetValuesQuery, it will always be 0, as there is no way to determine the match count. */
  matchCount: Scalars['Float'];
  /** Query outcome */
  outcome: Maybe<Outcome>;
  /** Plots for this graph. */
  plots: Array<Maybe<Plot>>;
  /** Start time and end time for the query in nanoseconds */
  resolvedTimeRange: LongRange;
  /** Provides various slice sizes when autoAlign = true, When autoAlign = false, sliceInfo = null */
  sliceInfo: Maybe<SliceInfo>;
  /** Timestamps for the xAxis of the graph. */
  xAxis: Maybe<Array<Scalars['Long']>>;
};

export type PlotQueryInput = {
  autoAggregate: InputMaybe<Scalars['Boolean']>;
  autoAlign: InputMaybe<Scalars['Boolean']>;
  breakdownFacet: InputMaybe<Scalars['String']>;
  expression: InputMaybe<Scalars['String']>;
  frequency: InputMaybe<QueryFrequency>;
  sliceWidth: InputMaybe<Scalars['String']>;
  slices: InputMaybe<Scalars['Int']>;
};

export type PowerQueryInput = {
  resultType: InputMaybe<ResultType>;
};

export type PqResultData = ResultData & {
  __typename?: 'PqResultData';
  /** List of cells in a row column format where cells[0][0], returns the cell from first column in the first row. */
  cells: Maybe<Array<Maybe<Array<Maybe<Cell>>>>>;
  columns: Maybe<Array<Maybe<Column>>>;
  keyColumns: Scalars['Int'];
  /** Count of events matched in this query. May be exact, but for many queries it will be approximate. For a few, for example FacetValuesQuery, it will always be 0, as there is no way to determine the match count. */
  matchCount: Scalars['Float'];
  omittedEvents: Scalars['Float'];
  /** Query outcome */
  outcome: Maybe<Outcome>;
  partialResultsDueToTimeLimit: Scalars['Boolean'];
  /** Start time and end time for the query in nanoseconds */
  resolvedTimeRange: LongRange;
  /** @deprecated field "values" has been replaced by the field "cells" */
  values: Maybe<Array<Maybe<Array<Maybe<Scalars['ObjectScalar']>>>>>;
  warnings: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type PreferenceHomepage = {
  __typename?: 'PreferenceHomepage';
  /** User default Homepage path (relative path) */
  path: Maybe<Scalars['String']>;
  /** Team name / email for the homepage */
  team: Maybe<Scalars['String']>;
};

export type PreferenceHomepageInput = {
  /** User default Homepage path (relative path) */
  path: InputMaybe<Scalars['String']>;
  /** Team name / email for the homepage */
  team: InputMaybe<Scalars['String']>;
};

export type QueriesResult = {
  __typename?: 'QueriesResult';
  /** Ids for each result. This is filled by launch query, where the caller can retrieve it, and then pass it as parameter to ping query's ids argument. See launch query description for details. */
  ids: Maybe<Array<Maybe<Scalars['String']>>>;
  /** List of results; one for each QueryRequestInput launched together. */
  results: Array<Maybe<QueryRequestResult>>;
  /** Status of the query. */
  status: Scalars['String'];
  /** Steps completed so far. */
  stepsCompleted: Scalars['Int'];
  /** Token for the client to use in order to ping or delete a query. */
  token: Scalars['String'];
  /** Total number of steps to complete. */
  totalSteps: Scalars['Int'];
};

/** Query root */
export type Query = {
  __typename?: 'Query';
  /** Provides information for user account */
  accountData: AccountData;
  /** Single alert information */
  alert: Maybe<AlertInfo>;
  /** List all of alerts for this account. There is a cap on the number of alerts returned by this query dictated by the knob maxAlertsToDisplay which defaults to 2000 */
  alerts: Maybe<Array<Maybe<AlertInfo>>>;
  /** Get information about global alert configuration for this account, including default alert notification address */
  alertsConfig: Maybe<AlertsConfig>;
  annotations: Maybe<Array<Maybe<Annotation>>>;
  /** Get billing notifications */
  billingNotifications: Maybe<BillingNotifications>;
  /** Get budget categories */
  budgetCategories: Maybe<Array<Maybe<BudgetCategory>>>;
  /** Service to export logs to Amazon s3 */
  bulkExport: BulkExportResolver;
  /** Gets configuration file by its id. */
  configFile: Maybe<ConfigFile>;
  /** Lists configuration files. */
  configFiles: Maybe<Array<Maybe<ConfigFile>>>;
  /**
   * List dashboards for current user.
   * @deprecated This one is used for old fashioned style dashboard without tabs, now it is temporary available until frontend release
   */
  dashboards: Array<Maybe<Dashboard>>;
  /** List dashboards for current user. */
  dashboardsV2: Array<Maybe<DashboardV2>>;
  /** Gets the currently logged in user's display settings for search based on scope. A scope of 'session' will retrieve settings applied for the current session. Display settings created with a scope of 'session' will be cleared with the browser cookie. A scope of 'account' will retrieve settings persisted for the account for the longer term. */
  displaySettings: Maybe<DisplaySettings>;
  /** Returns all the data required for help docs */
  docsData: DocsData;
  /** Lists features and corresponding access level for current user. */
  featurePermissions: FeaturePermissions;
  /** Get an existing dashboard config. */
  getDashboard: Maybe<Dashboard>;
  /** Get an existing dashboard config. */
  getDashboardV2: Maybe<DashboardV2>;
  /** Get log entry with all facets and whole unlimited facet values leveraging continuation token obtained previously from LOG type query */
  getLogEntry: Maybe<LogEntryEdgeResult>;
  /** Get top facet names, this type of query directly calls SummaryServiceQuerier */
  getTopFacetNames: TopFacetNamesResult;
  /** Returns all groups for specified accountId. */
  groups: Maybe<Array<Maybe<Group>>>;
  /** Provides information about the user's Hindsight usage & billing - plan, cost of storage and cost of issued queries */
  hindsightData: Maybe<HindsightDataResolver>;
  /** Returns true if we can create a new login session for the demo account and not exceed the active user limit. */
  isDemoAccountAvailable: Scalars['Boolean'];
  /** Checks whether the s1 user is still active in console */
  isS1UserActive: Maybe<Scalars['Boolean']>;
  /** List api keys visible for this account. */
  keys: Maybe<Array<Maybe<Key>>>;
  /** Lists labs allowed for this account */
  labs: Maybe<Array<Maybe<Lab>>>;
  /** Launch a dashboard query. Similar to `launchQuery` but specific to dashboard elements. */
  launchDashboardQuery: QueriesResult;
  /**
   * Launch a query. On return the result will have the currently known results, which may be refined. To get the refined results, the caller should loop calling pingQuery, passing QueriesResult.token and QueriesResult.ids. The loop should stop when QueriesResult.stepsCompleted == QueriesResult.totalSteps. NOTE: the caller MUST ensure that the ids passed to pingQuery match the ids returned here as QueriesResult.ids.Example:
   * results = launchQuery(request);
   * while (results.stepsCompleted < results.totalSteps) {
   *   process(results);
   *   results = pingQuery(results.token, results.ids, results.stepsCompleted);
   * }
   * process(results);
   */
  launchQuery: QueriesResult;
  /** Lists the account's bulk exports */
  listJobs: Maybe<Array<Maybe<BulkExport>>>;
  /**
   * Get a snapshot of current logs uploaded by the user.
   * LiveTail results are only from the time of the api call.
   * Also, the user isn't guaranteed to see everything. If the your LiveTail filter matches zillions of events, only a sample of events fulfilling the live tail options is returned.
   */
  liveTail: LiveTail;
  /** Returns log volumes for specified period */
  logVolumes: Maybe<BudgetVolume>;
  /** Returns log volumes grouped by category for specified period */
  logVolumesByCategory: Maybe<Array<Maybe<BudgetCategoryVolume>>>;
  /** Parse invite token. */
  parseInviteToken: Maybe<InviteLinkToken>;
  /** Get parser by id */
  parser: Maybe<Parser>;
  /** List of build in and custom parsers. */
  parsers: Maybe<Array<Maybe<Parser>>>;
  /** Ping a query. Get the currently known results. See launchQuery description for details on how to use launchQuery and pingQuery together. */
  pingQuery: Maybe<QueriesResult>;
  /** Provides preferences for the user */
  preferences: UserPreferences;
  /** Gets details of an S1 endpoint */
  s1Endpoint: Maybe<S1Endpoint>;
  /** Lists saved searches for the account */
  savedSearches: Array<Maybe<SavedSearch>>;
  /** Returns all scrubbing rules for specified accountId. */
  scrubbingRules: Maybe<Array<Maybe<ScrubbingRuleRequestBody>>>;
  /** Get secret by name */
  secret: Maybe<Secret>;
  /** List of all customer secrets. */
  secrets: Maybe<Array<Maybe<Secret>>>;
  /** Lists services detected for this account */
  services: Array<Maybe<ServiceState>>;
  /** Get value of 'slackAuthApi' knob. */
  slackAuthApi: Scalars['String'];
  /** Get user's selected slack channels and the user name who is going to send the message. */
  slackChannels: Maybe<SlackChannels>;
  /** Get value of 'slackClientId' knob. */
  slackClientId: Scalars['String'];
  /** Lists sources sending data to this account */
  sources: Sources;
  /** Service performance monitoring object */
  spm: SPM;
  /** Retrieve system settings for this user's account. */
  systemSettings: Maybe<SystemSettings>;
  /** Lists user accounts */
  userAccounts: Array<Maybe<UserAccount>>;
  /** Return a user's login status. */
  userLoginState: Maybe<UserLoginState>;
};


/** Query root */
export type QueryalertArgs = {
  id: Scalars['String'];
};


/** Query root */
export type QueryannotationsArgs = {
  endMs: Scalars['Long'];
  startMs: Scalars['Long'];
};


/** Query root */
export type QueryconfigFileArgs = {
  id: InputMaybe<Scalars['ID']>;
};


/** Query root */
export type QuerygetDashboardArgs = {
  dashboardName: Scalars['String'];
  resolveParameters: InputMaybe<Scalars['Boolean']>;
};


/** Query root */
export type QuerygetDashboardV2Args = {
  dashboardName: Scalars['String'];
  resolveParameters: InputMaybe<Scalars['Boolean']>;
};


/** Query root */
export type QuerygetLogEntryArgs = {
  continuationToken: Scalars['String'];
};


/** Query root */
export type QuerygetTopFacetNamesArgs = {
  queryRequest: QueryRequestInput;
};


/** Query root */
export type QueryhindsightDataArgs = {
  endDate: Scalars['String'];
  startDate: Scalars['String'];
};


/** Query root */
export type QueryisS1UserActiveArgs = {
  managementConsoleUrl: InputMaybe<Scalars['String']>;
};


/** Query root */
export type QuerylaunchDashboardQueryArgs = {
  dashboardQuery: DashboardQueryGroupInput;
};


/** Query root */
export type QuerylaunchQueryArgs = {
  queryGroupRequest: QueryGroupRequestInput;
};


/** Query root */
export type QuerylogVolumesArgs = {
  end: InputMaybe<Scalars['String']>;
  start: InputMaybe<Scalars['String']>;
};


/** Query root */
export type QuerylogVolumesByCategoryArgs = {
  end: InputMaybe<Scalars['String']>;
  start: InputMaybe<Scalars['String']>;
};


/** Query root */
export type QueryparseInviteTokenArgs = {
  token: Scalars['String'];
};


/** Query root */
export type QueryparserArgs = {
  id: Scalars['ID'];
};


/** Query root */
export type QuerypingQueryArgs = {
  ids: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lastStepSeen: Scalars['Int'];
  token: Scalars['String'];
};


/** Query root */
export type Querys1EndpointArgs = {
  agentUUID: InputMaybe<Scalars['String']>;
  managementConsoleUrl: InputMaybe<Scalars['String']>;
};


/** Query root */
export type QuerysavedSearchesArgs = {
  type: SavedSearchType;
};


/** Query root */
export type QuerysecretArgs = {
  name: Scalars['ID'];
};


/** Query root */
export type QuerysourcesArgs = {
  showOld: Scalars['Boolean'];
  teamEmails: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** Query root */
export type QueryuserLoginStateArgs = {
  email: Scalars['String'];
};

export enum QueryFrequency {
  /** A query frequency is considered HIGH if the same query could be called multiple times in a short time frame.Eg : Dashboard, Alerting system, or any other automated tool */
  HIGH = 'HIGH',
  /** A query frequency is considered LOW, if the queries are made by a user, in a non automated way */
  LOW = 'LOW'
}

export type QueryGroupRequestInput = {
  preFilter: InputMaybe<Scalars['String']>;
  queries: Array<InputMaybe<QueryRequestInput>>;
};

export enum QueryOrigin {
  /** Queries are from the Alert page */
  ALERT = 'ALERT',
  /** Queries are from the Billing page */
  BILLING = 'BILLING',
  /** Queries are from the Dashboard page */
  DASHBOARD = 'DASHBOARD',
  /** Queries are from the Dashboard auto refresh page */
  DASHBOARD_AUTO_REFRESH = 'DASHBOARD_AUTO_REFRESH',
  /** Queries are from the Graph page */
  GRAPH = 'GRAPH',
  /** Queries are from the Overview page */
  OVERVIEW = 'OVERVIEW',
  /** Queries are from the Event Search page */
  SEARCH = 'SEARCH',
  /** Default case */
  UNKNOWN = 'UNKNOWN'
}

export enum QueryPriority {
  /** Standard query priority for API requests, with tighter rate limits. */
  HIGH = 'HIGH',
  /** Use low priority for scripted queries where a slight delay is acceptable; low priority queries are less subject to rate limiting. */
  LOW = 'LOW'
}

export type QueryRequestInput = {
  ascending: InputMaybe<Scalars['Boolean']>;
  endTime: InputMaybe<Scalars['String']>;
  facet: InputMaybe<Scalars['String']>;
  facetQuery: InputMaybe<FacetQueryInput>;
  facetValuesQuery: InputMaybe<FacetValuesQueryInput>;
  filter: InputMaybe<Scalars['String']>;
  id: InputMaybe<Scalars['String']>;
  numResults: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['String']>;
  origin: InputMaybe<QueryOrigin>;
  plotQuery: InputMaybe<PlotQueryInput>;
  powerQuery: InputMaybe<PowerQueryInput>;
  priority: InputMaybe<QueryPriority>;
  startTime: InputMaybe<Scalars['String']>;
  teamEmails: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  type: InputMaybe<QueryType>;
};

export type QueryRequestResult = {
  __typename?: 'QueryRequestResult';
  /** Result data. If null, the query was not executed. Check error field */
  data: Maybe<ResultData>;
  /** Error if the query was not executed. If not null, will always have "message" key which will provide the basic error message and an optional "details" field providing further information.If the query execution was successful, the error field will be null. */
  error: Maybe<Scalars['Map_String_ObjectScalar']>;
  /** QueryRequest identifier. Provided by caller either as part of launch query's QueryGroupRequest.queries, or as the parameter to ping query's ids argument. */
  id: Maybe<Scalars['String']>;
  /** Number of steps completed in this long running query. */
  stepsCompleted: Scalars['Int'];
  /** Total number of steps to execute. */
  totalSteps: Scalars['Int'];
};

export enum QueryType {
  /**
   * A Breakdown query, which in current implementation bypasses LRQ manager.## Sample Query:
   * ```
   *     "queries": [
   *       {
   *         "startTime": "3 hours",
   *         "type": "BREAKDOWN",
   *         "plotQuery": {
   *           "slices": 10,
   *           "breakdownFacet": "serverHost",
   *           "expression": "max(latency where $app = 'Scalyr')"
   *         }
   *       }
   * ```
   */
  BREAKDOWN = 'BREAKDOWN',
  /** Map, as a histogram, the distribution of values for a facet */
  DISTRIBUTION = 'DISTRIBUTION',
  /** Find the top values for a particular facet across all matching events. */
  FACET_VALUES = 'FACET_VALUES',
  /** Fetch a time-ordered list of matching events, with support for pagination. */
  LOG = 'LOG',
  /** Generate a plot of a numeric function applied to all matching events. */
  PLOT = 'PLOT',
  /** A PowerQuery */
  PQ = 'PQ',
  /**
   * Reports allow you to summarize data about a collection of entities and present it in a table.
   * @deprecated Should use type = PQ instead of reports
   */
  REPORT = 'REPORT',
  /** Find the top facets & facet values for all matching events. */
  TOP_FACETS = 'TOP_FACETS',
  /** Find the top facets with no values attached. */
  TOP_FACET_NAMES = 'TOP_FACET_NAMES'
}

export enum RepoEventType {
  end = 'end',
  event = 'event',
  start = 'start'
}

export type ResultData = {
  /** Count of events matched in this query. May be exact, but for many queries it will be approximate. For a few, for example FacetValuesQuery, it will always be 0, as there is no way to determine the match count. */
  matchCount: Scalars['Float'];
  /** Query outcome */
  outcome: Maybe<Outcome>;
  /** Start time and end time for the query in nanoseconds */
  resolvedTimeRange: LongRange;
};

export enum ResultType {
  /** [Default] Fetch the data as a table. PqResultData in graphQL schema */
  COLUMN = 'COLUMN',
  /** Fetch the data as graph. PlotData in graphQL schema. When specifying resultType = PLOT, user should make sure that the PQ output will be of format <column1, column 2, ... column n> , where column1 is time column is time, measured in seconds, milliseconds, microseconds, or nanoseconds from 1/1/1970 andcolumn2 .. column n are numeric values. column1 will be the x axis and column2 .. column n will be plotted as separate plots. */
  PLOT = 'PLOT'
}

export type S1ActiveDirectory = {
  __typename?: 'S1ActiveDirectory';
  computerDistinguishedName: Maybe<Scalars['String']>;
  computerMemberOf: Maybe<Array<Maybe<Scalars['String']>>>;
  lastUserDistinguishedName: Maybe<Scalars['String']>;
  lastUserMemberOf: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type S1Application = {
  __typename?: 'S1Application';
  /** Date of installation of the application */
  installedDate: Maybe<Scalars['String']>;
  /** Name of the application */
  name: Maybe<Scalars['String']>;
  /** Publisher of the application */
  publisher: Maybe<Scalars['String']>;
  /** Size of the application */
  size: Maybe<Scalars['String']>;
  /** Installed version of the application */
  version: Maybe<Scalars['String']>;
};

export type S1ApplicationsResponse = {
  __typename?: 'S1ApplicationsResponse';
  /** List of applications */
  data: Maybe<Array<Maybe<S1Application>>>;
  /** Pagination details */
  pagination: Maybe<PaginationDetails>;
};

export type S1AvailableAction = {
  __typename?: 'S1AvailableAction';
  /** Reason for the action being disabled for this user */
  disabledReason: Maybe<Scalars['String']>;
  /** Whether the action is disabled for this user */
  isDisabled: Scalars['Boolean'];
  /** Name of the action, can be used an as Id since it is unique */
  name: Maybe<Scalars['String']>;
};

export type S1AvailableActionsResponse = {
  __typename?: 'S1AvailableActionsResponse';
  /** List of available actions */
  data: Maybe<Array<Maybe<S1AvailableAction>>>;
};

export type S1CloudProvider = {
  __typename?: 'S1CloudProvider';
  name: Maybe<Scalars['String']>;
  value: Maybe<S1CloudProviderData>;
};

export type S1CloudProviderData = {
  __typename?: 'S1CloudProviderData';
  agentNamespace: Maybe<Scalars['String']>;
  agentPodName: Maybe<Scalars['String']>;
  awsRole: Maybe<Scalars['String']>;
  awsSecurityGroups: Maybe<Array<Maybe<Scalars['String']>>>;
  awsSubnetIds: Maybe<Array<Maybe<Scalars['String']>>>;
  azureResourceGroup: Maybe<Scalars['String']>;
  cloudAccount: Maybe<Scalars['String']>;
  cloudImage: Maybe<Scalars['String']>;
  cloudInstanceId: Maybe<Scalars['String']>;
  cloudInstanceSize: Maybe<Scalars['String']>;
  cloudLocation: Maybe<Scalars['String']>;
  cloudNetwork: Maybe<Scalars['String']>;
  cloudTags: Maybe<Array<Maybe<Scalars['String']>>>;
  clusterName: Maybe<Scalars['String']>;
  gcpServiceAccount: Maybe<Scalars['String']>;
  kubernetesNodeLabels: Maybe<Array<Maybe<Scalars['String']>>>;
  kubernetesNodeName: Maybe<Scalars['String']>;
  kubernetesType: Maybe<Scalars['String']>;
  kubernetesVersion: Maybe<Scalars['String']>;
};

export type S1Endpoint = {
  __typename?: 'S1Endpoint';
  accountId: Maybe<Scalars['String']>;
  accountName: Maybe<Scalars['String']>;
  activeDirectory: Maybe<S1ActiveDirectory>;
  activeThreats: Scalars['Int'];
  agentVersion: Maybe<Scalars['String']>;
  allowRemoteShell: Scalars['Boolean'];
  /** Applications installed on this endpoint */
  applications: Maybe<S1ApplicationsResponse>;
  appsVulnerabilityStatus: Maybe<Scalars['String']>;
  /** Available actions for this endpoint */
  availableActions: Maybe<S1AvailableActionsResponse>;
  /** Cloud provider information */
  cloudProviders: Maybe<Array<Maybe<S1CloudProvider>>>;
  computerName: Maybe<Scalars['String']>;
  consoleMigrationState: Maybe<Scalars['String']>;
  coreCount: Scalars['Int'];
  cpuCount: Scalars['Int'];
  cpuId: Maybe<Scalars['String']>;
  createdAt: Maybe<Scalars['String']>;
  domain: Maybe<Scalars['String']>;
  encryptedApplications: Scalars['Boolean'];
  externalId: Maybe<Scalars['String']>;
  externalIp: Maybe<Scalars['String']>;
  firewallEnabled: Scalars['Boolean'];
  groupId: Maybe<Scalars['String']>;
  groupIp: Maybe<Scalars['String']>;
  groupName: Maybe<Scalars['String']>;
  id: Maybe<Scalars['String']>;
  inRemoteShellSession: Scalars['Boolean'];
  infected: Scalars['Boolean'];
  installerType: Maybe<S1InstallerType>;
  isActive: Scalars['Boolean'];
  isDecommissioned: Scalars['Boolean'];
  isPendingUninstall: Scalars['Boolean'];
  isUninstalled: Scalars['Boolean'];
  isUpToDate: Scalars['Boolean'];
  lastActiveDate: Maybe<Scalars['String']>;
  lastIpToMgmt: Maybe<Scalars['String']>;
  lastLoggedInUserName: Maybe<Scalars['String']>;
  licenseKey: Maybe<Scalars['String']>;
  locationEnabled: Scalars['Boolean'];
  locationType: Maybe<Scalars['String']>;
  locations: Maybe<Array<Maybe<S1Location>>>;
  machineType: Maybe<Scalars['String']>;
  mitigationMode: Maybe<Scalars['String']>;
  mitigationModeSuspicious: Maybe<Scalars['String']>;
  modelName: Maybe<Scalars['String']>;
  networkInterfaces: Maybe<Array<Maybe<S1NetworkInterface>>>;
  networkQuarantineEnabled: Scalars['Boolean'];
  networkStatus: Maybe<Scalars['String']>;
  operationalState: Maybe<Scalars['String']>;
  operationalStateExpiration: Maybe<Scalars['String']>;
  osArch: Maybe<Scalars['String']>;
  osName: Maybe<Scalars['String']>;
  osRevision: Maybe<Scalars['String']>;
  osStartTime: Maybe<Scalars['String']>;
  osType: Maybe<Scalars['String']>;
  osUsername: Maybe<Scalars['String']>;
  rangerStatus: Maybe<Scalars['String']>;
  rangerVersion: Maybe<Scalars['String']>;
  registeredAt: Maybe<Scalars['String']>;
  remoteProfilingState: Maybe<Scalars['String']>;
  remoteProfilingStateExpiration: Maybe<Scalars['String']>;
  scanAbortedAt: Maybe<Scalars['String']>;
  scanFinishedAt: Maybe<Scalars['String']>;
  scanStartedAt: Maybe<Scalars['String']>;
  scanStatus: Maybe<Scalars['String']>;
  serialNumber: Maybe<Scalars['String']>;
  siteId: Maybe<Scalars['String']>;
  siteName: Maybe<Scalars['String']>;
  storageName: Maybe<Scalars['String']>;
  storageType: Maybe<Scalars['String']>;
  /** List of tags for this endpoint */
  tags: Maybe<Array<Maybe<S1Tag>>>;
  /** Tasks related to this endpoint */
  tasks: Maybe<S1TasksResponse>;
  threatCount: Scalars['Int'];
  threatRebootRequired: Scalars['Boolean'];
  totalMemory: Scalars['Int'];
  updatedAt: Maybe<Scalars['String']>;
  userActionsNeeded: Maybe<Array<Maybe<Scalars['String']>>>;
  uuid: Maybe<Scalars['String']>;
};

export type S1GenericAgentActionResponse = {
  __typename?: 'S1GenericAgentActionResponse';
  /** Agent action response data */
  data: Maybe<S1GenericAgentActionResponseData>;
};

export type S1GenericAgentActionResponseData = {
  __typename?: 'S1GenericAgentActionResponseData';
  /** Number of agents affected */
  affected: Scalars['Int'];
};

export enum S1InstallerType {
  bsx = 'bsx',
  deb = 'deb',
  exe = 'exe',
  img = 'img',
  msi = 'msi',
  pkg = 'pkg',
  rpm = 'rpm',
  tar = 'tar',
  unknown = 'unknown',
  zip = 'zip'
}

export type S1Location = {
  __typename?: 'S1Location';
  id: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
  scope: Maybe<S1ManagementScope>;
};

export enum S1ManagementScope {
  account = 'account',
  global = 'global',
  group = 'group',
  site = 'site',
  tenant = 'tenant'
}

export type S1NetworkInterface = {
  __typename?: 'S1NetworkInterface';
  gatewayIp: Maybe<Scalars['String']>;
  gatewayMacAddress: Maybe<Scalars['String']>;
  id: Maybe<Scalars['String']>;
  inet: Maybe<Array<Maybe<Scalars['String']>>>;
  inet6: Maybe<Array<Maybe<Scalars['String']>>>;
  name: Maybe<Scalars['String']>;
  physical: Maybe<Scalars['String']>;
};

export type S1Tag = {
  __typename?: 'S1Tag';
  name: Maybe<Scalars['String']>;
  value: Maybe<Array<Maybe<ManagementTag>>>;
};

export enum S1TagAssignmentMethod {
  auto_tagging = 'auto_tagging',
  manual_tagging = 'manual_tagging'
}

export enum S1TagType {
  agents = 'agents',
  threats = 'threats'
}

export type S1Task = {
  __typename?: 'S1Task';
  /** AccountId that created this task */
  accountId: Maybe<Scalars['String']>;
  /** Name of the account */
  accountName: Maybe<Scalars['String']>;
  agentComputerName: Maybe<Scalars['String']>;
  agentId: Maybe<Scalars['String']>;
  agentIsActive: Maybe<Scalars['Boolean']>;
  agentIsDecommissioned: Maybe<Scalars['Boolean']>;
  agentMachineType: Maybe<Scalars['String']>;
  agentOsType: Maybe<Scalars['String']>;
  agentUuid: Maybe<Scalars['String']>;
  createdAt: Maybe<Scalars['String']>;
  description: Maybe<Scalars['String']>;
  detailedState: Maybe<Scalars['String']>;
  groupId: Maybe<Scalars['String']>;
  groupName: Maybe<Scalars['String']>;
  id: Maybe<Scalars['String']>;
  /** User who initiated this task */
  initiatedBy: Maybe<Scalars['String']>;
  /** Id of the user who initiated this task */
  initiatedById: Maybe<Scalars['String']>;
  parentTaskId: Maybe<Scalars['String']>;
  scriptResultsSignature: Maybe<Scalars['String']>;
  siteId: Maybe<Scalars['String']>;
  siteName: Maybe<Scalars['String']>;
  status: Maybe<Scalars['String']>;
  statusDescription: Maybe<Scalars['String']>;
  type: Maybe<Scalars['String']>;
  updatedAt: Maybe<Scalars['String']>;
};

export type S1TasksResponse = {
  __typename?: 'S1TasksResponse';
  /** List of tasks */
  data: Maybe<Array<Maybe<S1Task>>>;
  /** Pagination details */
  pagination: Maybe<PaginationDetails>;
};

export type SPM = {
  __typename?: 'SPM';
  /** Give a complete snapshots for services monitored by SPM */
  overview: Array<Maybe<SPMServiceInfo>>;
};


export type SPMoverviewArgs = {
  includePreviousWeek: Scalars['Boolean'];
};

export type SPMOperation = {
  __typename?: 'SPMOperation';
  current: Maybe<Data>;
  operationName: Maybe<Scalars['String']>;
  previous: Maybe<Data>;
  status: Maybe<Scalars['String']>;
  troubleScore: Scalars['Float'];
};

export type SPMOverviewMetrics = {
  __typename?: 'SPMOverviewMetrics';
  errorRate: Scalars['Float'];
  latencyAvg: Scalars['Float'];
  trafficRate: Scalars['Float'];
};

export type SPMServiceInfo = {
  __typename?: 'SPMServiceInfo';
  metrics: Maybe<SPMOverviewMetrics>;
  operations: Maybe<Array<Maybe<SPMOperation>>>;
  serviceName: Maybe<Scalars['String']>;
  status: Maybe<Scalars['String']>;
  troubleScore: Scalars['Float'];
};

export type SavedSearch = {
  __typename?: 'SavedSearch';
  /** Index of the saved search. */
  index: Scalars['Int'];
  /** Name of the saved search. */
  name: Scalars['String'];
  /** Type of the saved search */
  type: SavedSearchType;
  /** Search url. */
  url: Scalars['String'];
};

export enum SavedSearchType {
  /** Search created by user and not shared with anyone. */
  PRIVATE = 'PRIVATE',
  /** Search created by user and shared with everyone in the same account. */
  SHARED = 'SHARED'
}

export enum Scope {
  /** Setting applied to the account linked to the user */
  account = 'account',
  /** Setting applied to all the accounts linked to the user */
  global = 'global',
  /** Setting applied to session linked to the user */
  session = 'session'
}

export type ScrubbingRuleRequestBody = {
  __typename?: 'ScrubbingRuleRequestBody';
  /** The unique identifier of this rule. */
  id: Maybe<Scalars['Int']>;
  /** Defines which log entries this rule should be applied to. */
  logFilter: Scalars['String'];
  /** Regex pattern to look for in logs. */
  matchText: Scalars['String'];
  /** name of the rule. */
  name: Scalars['String'];
  /**
   * Position of this rule in the list of all rules for specified account.
   * Rules are applied to log messages in order spec position.
   */
  position: Maybe<Scalars['Int']>;
  /** Text to put in place of found matches, can be empty. */
  replaceWith: Maybe<Scalars['String']>;
};

export type ScrubbingRuleRequestBodyInput = {
  /** The unique identifier of this rule. */
  id: InputMaybe<Scalars['Int']>;
  logFilter: Scalars['String'];
  matchText: Scalars['String'];
  name: Scalars['String'];
  /**
   * Position of this rule in the list of all rules for specified account.
   * Rules are applied to log messages in order spec position.
   */
  position: InputMaybe<Scalars['Int']>;
  replaceWith: InputMaybe<Scalars['String']>;
};

export type SearchResultLink = {
  __typename?: 'SearchResultLink';
  caseSensitive: Scalars['Boolean'];
  /**
   * (optional)
   * The number of the captured argument to use as the link text (rather than the entire matched text).
   */
  linkTextArg: Maybe<Scalars['Int']>;
  /** A Javascript regular expression to match values against. Use parentheses to capture text for use in the URL. Captured text is numbered in order of left parentheses, starting with 1. Any backslashes in the regex will need to be escaped (doubled).  */
  regex: Maybe<Scalars['String']>;
  /**
   * (optional)
   * A comma-separated list of fields (facets) to match against, or `* to match against all fields. Defaults to the raw log line (also called message). In addition to any facet pulled out by the parser, it can include the system fields serverHost, logfile, and/or message.
   */
  searchFields: Maybe<Array<Maybe<Scalars['String']>>>;
  /**
   * (optional)
   * Used to perform transformations on captured arguments. Refer https://app.scalyr.com/help/smart-links for examples
   *
   */
  subs: Maybe<Array<Maybe<Substitution>>>;
  /** The target url with pattern matchers from the regex   */
  url: Maybe<Scalars['String']>;
};

export type Secret = {
  __typename?: 'Secret';
  /** The person who created or modified this secret. */
  author: Maybe<Scalars['String']>;
  /** Date when secret was created or last modified. */
  createDate: Maybe<Scalars['String']>;
  /** Optional Details about the secret. */
  description: Maybe<Scalars['String']>;
  /** Masked secret value made available for cross referencing with other systems. */
  maskedSecret: Maybe<Scalars['String']>;
  /** Name used for references to the secret. */
  name: Maybe<Scalars['ID']>;
};

export type ServiceState = {
  __typename?: 'ServiceState';
  operations: Array<Maybe<Scalars['String']>>;
  service: Scalars['String'];
};

export type SilenceConditionInput = {
  alertId: Scalars['String'];
  condition: InputMaybe<Scalars['String']>;
};

export type SlackChannelInfo = Node & {
  __typename?: 'SlackChannelInfo';
  /** Channel id. */
  id: Scalars['ID'];
  /** Channel name. */
  name: Scalars['String'];
};

export type SlackChannelInfoInput = {
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type SlackChannels = {
  __typename?: 'SlackChannels';
  /** List of channels. */
  channels: Array<Maybe<SlackChannelInfo>>;
  /** User name. */
  userName: Scalars['String'];
};

export type SliceInfo = {
  __typename?: 'SliceInfo';
  /** The size of all the slices in milli seconds except possibly the first and last. */
  defaultSize: Scalars['Float'];
  /** The size of the first slice in milli seconds. This can be less than the sizes for subsequent slices due to alignment. */
  firstSize: Scalars['Float'];
  /** The size of the last slice in milli seconds. This can be less than the sizes of earlier slices due to alignment. */
  lastSize: Scalars['Float'];
  /** The number of slices the query is now divided into. numSlices could be greater than requested slices if autoAlign is true */
  numSlices: Scalars['Int'];
};

export enum SortOrder {
  /** Search results are sorted by timestamp with the most recent events at the bottom of the scroll container. */
  MOST_RECENT_AT_BOTTOM = 'MOST_RECENT_AT_BOTTOM',
  /** Search results are sorted by timestamp with the most recent events at the top of the scroll container. */
  MOST_RECENT_AT_TOP = 'MOST_RECENT_AT_TOP'
}

export enum Source {
  API = 'API',
  NONE = 'NONE',
  OTHER = 'OTHER',
  SAML = 'SAML',
  SCIM = 'SCIM',
  WEB = 'WEB'
}

export type Sources = {
  __typename?: 'Sources';
  hosts: Maybe<Array<Maybe<Host>>>;
  kubeClusters: Maybe<Array<Maybe<KubeCluster>>>;
  /** Total hosts for the user without any filtering */
  totalHosts: Maybe<Scalars['Int']>;
  /** Total logs for the user without any filtering */
  totalLogs: Maybe<Scalars['Int']>;
};

export enum Status {
  CANCELED = 'CANCELED',
  CANCEL_REQ = 'CANCEL_REQ',
  COMPLETE = 'COMPLETE',
  FAILED = 'FAILED',
  NO_DATA = 'NO_DATA',
  PENDING = 'PENDING',
  WORKING = 'WORKING'
}

export enum StatusType {
  ACTIVE = 'ACTIVE',
  INVITED = 'INVITED'
}

export type Substitution = {
  __typename?: 'Substitution';
  /** Argument to transform */
  arg: Maybe<Scalars['Int']>;
  /** A regex matching text to transform */
  match: Maybe<Scalars['String']>;
  /** Replacement text */
  replace: Maybe<Scalars['String']>;
};

export enum SystemField {
  date = 'date',
  host = 'host',
  logfile = 'logfile',
  rawLogLine = 'rawLogLine',
  source = 'source',
  timestamp = 'timestamp'
}

export type SystemSettings = {
  __typename?: 'SystemSettings';
  /** Used on scalyr web client. Determine whether or not to send a new search query whenever any field is changed,vs only issuing a new query when the user clicks the update button */
  autoUpdateSearch: Scalars['Boolean'];
  /** Used on scalyr web client, overview page, when the user has *not* clicked "show all", shows hosts and logs which have received data up to this many hours ago */
  defaultAgeLimitHoursInOverviewPage: Scalars['Int'];
  /** The default time span that we'll use to search against.  May be user specified in /scalyr/logs.  If unsetthe system default is 4 hours */
  defaultSearchTimeSpan: Maybe<Scalars['String']>;
  /** Used on scalyr web client. Determine whether or not to hide API keys. */
  enableHiddenApiKeys: Scalars['Boolean'];
  /** Default logs per host in the Overview page */
  logsPerHostInOverviewPage: Scalars['Int'];
  /** Used on scalyr web client. Duration around a selected event, for events to select, when user asks to see surrounding events in original log or thread log. */
  originalLogOrThreadTimeNs: Scalars['Long'];
  /** Names of pages to exclude for the email verification check for trial accounts */
  pagesExcludedForTrialEmailVerification: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Names of paths that will be redirected to react app */
  reactPaths: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Names of pages that will not be redirected to react, but will be served by legacy app */
  reactPathsBlacklist: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Smart links from recognized portions of log lines. Refer to https://app.scalyr.com/help/smart-links. */
  searchResultLinks: Maybe<Array<Maybe<SearchResultLink>>>;
  /** Used on scalyr web client, overview page, when the user has clicked "show all", shows hosts and logs which have received data up to this many hours ago */
  showAllAgeLimitHoursInOverviewPage: Scalars['Int'];
  /** Used on Scalyr web client. Stripe API publishable key. */
  stripePublishableKey: Scalars['String'];
  /** Used on scalyr web client. Determine whether or not to unescape backslashed characters in the logline message */
  unescapeLogLineMessage: Scalars['Boolean'];
};

export type TeamData = {
  __typename?: 'TeamData';
  /** The email address of the team account. */
  emailAddress: Scalars['String'];
  /** The id of the team account. */
  id: Scalars['String'];
  /** The name of the team account, can be null. */
  name: Maybe<Scalars['String']>;
};

export enum Theme {
  dark = 'dark',
  scalyr = 'scalyr',
  sentinel_one = 'sentinel_one',
  sentinel_one_dark = 'sentinel_one_dark',
  singularity = 'singularity',
  singularity_dark = 'singularity_dark'
}

export type TopFacetNamesResult = {
  __typename?: 'TopFacetNamesResult';
  /** errorString */
  errorString: Maybe<Scalars['String']>;
  /** names */
  names: Maybe<Array<Maybe<Scalars['String']>>>;
  /** outcome */
  outcome: Maybe<Outcome>;
};

export enum Type {
  /** Api key type of config. */
  CONFIG = 'CONFIG',
  /** Api key type of log. */
  LOG = 'LOG'
}

export type UserAccount = {
  __typename?: 'UserAccount';
  /** User access */
  access: AccessType;
  /** User email */
  email: Scalars['String'];
  /** User account creation source */
  source: Source;
  /** User status */
  status: StatusType;
};

export type UserLoginState = {
  __typename?: 'UserLoginState';
  /** Does this user have a valid SSO config */
  hasValidSsoConfig: Scalars['Boolean'];
  /** Is password login enabled for this user */
  passwordLoginEnabled: Maybe<Scalars['Boolean']>;
  /** Does this user need an SSO invite */
  ssoInviteRequired: Scalars['Boolean'];
  /** Is SSO login enabled for this user */
  ssoLoginEnabled: Maybe<Scalars['Boolean']>;
};

export type UserPreferences = {
  __typename?: 'UserPreferences';
  /** User default Homepage (relative path) per each of user's team */
  homepages: Maybe<Array<Maybe<PreferenceHomepage>>>;
  /** Preferred timezone for the user e.g. Asia/Kolkata */
  timezone: Maybe<Scalars['String']>;
};

export type Value = {
  __typename?: 'Value';
  /** Number of times this facet value appeared in the events matched. */
  count: Scalars['Long'];
  /** Facet value. */
  value: Scalars['ObjectScalar'];
};
